var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _g, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactUsRafikiIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 382.4H0V382.65H500V382.4Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9 398.49H416.78V398.74H449.9V398.49Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.22 401.211H322.53V401.461H331.22V401.211Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M415.78 389.211H396.59V389.461H415.78V389.211Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.65 390.891H52.46V391.141H95.65V390.891Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.89 390.891H104.56V391.141H110.89V390.891Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.15 395.109H131.47V395.359H225.15V395.109Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237 337.8H43.91C42.3973 337.797 40.9475 337.195 39.8788 336.124C38.8102 335.053 38.21 333.603 38.21 332.09V60.66C38.2231 59.156 38.8292 57.718 39.8964 56.6582C40.9637 55.5985 42.4059 55.0026 43.91 55H237C238.514 55 239.967 55.6016 241.038 56.6724C242.108 57.7433 242.71 59.1956 242.71 60.71V332.09C242.71 333.604 242.108 335.057 241.038 336.128C239.967 337.198 238.514 337.8 237 337.8ZM43.91 55.2C42.4636 55.2026 41.0774 55.7791 40.0556 56.8027C39.0338 57.8264 38.46 59.2136 38.46 60.66V332.09C38.46 333.536 39.0338 334.924 40.0556 335.947C41.0774 336.971 42.4636 337.547 43.91 337.55H237C238.447 337.547 239.834 336.971 240.858 335.948C241.881 334.924 242.457 333.537 242.46 332.09V60.66C242.457 59.2127 241.881 57.8255 240.858 56.8021C239.834 55.7787 238.447 55.2026 237 55.2H43.91Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M453.31 337.8H260.21C258.696 337.797 257.246 337.195 256.175 336.125C255.105 335.054 254.503 333.604 254.5 332.09V60.66C254.516 59.1551 255.124 57.7171 256.193 56.6576C257.262 55.5981 258.705 55.0025 260.21 55H453.31C454.812 55.0052 456.252 55.6022 457.317 56.6617C458.382 57.7212 458.987 59.1578 459 60.66V332.09C459 333.601 458.401 335.05 457.335 336.121C456.268 337.191 454.821 337.795 453.31 337.8ZM260.21 55.2C258.763 55.2026 257.375 55.7787 256.352 56.8021C255.329 57.8255 254.753 59.2127 254.75 60.66V332.09C254.753 333.537 255.329 334.924 256.352 335.948C257.375 336.971 258.763 337.547 260.21 337.55H453.31C454.757 337.547 456.145 336.971 457.168 335.948C458.191 334.924 458.767 333.537 458.77 332.09V60.66C458.767 59.2127 458.191 57.8255 457.168 56.8021C456.145 55.7787 454.757 55.2026 453.31 55.2H260.21Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M445.42 117.18H203.14V350.72H445.42V117.18Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M445.42 121.42H207.03V346.64H445.42V121.42Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.79 292.101V224.351H215.82V215.401L231.66 208.001V198.841H234.3V224.351H236.94V292.101H240.46V256.901H248.38V238.431H251.02V292.101H257.17V271.861H261.57V266.581H271.25V248.111H276.53V235.791H282.69V217.311H285.33V235.791H291.49V248.111H296.76V266.581H306.44V271.861H310.84V292.101H316.12V266.581H325.8V210.281H328.44V204.121H349.55V210.281H353.95V250.751H371.55V255.141H377.7V257.781H371.55V273.621H390.02V220.831H393.54V210.281H402.34V169.811H404.98V210.281H411.14V220.831H445.42V346.641H207.03V292.101H208.79Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 223.59H424.61V226.08H427.1V223.59Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 227.77H424.61V230.26H427.1V227.77Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 244.49H424.61V246.98H427.1V244.49Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 248.66H424.61V251.15H427.1V248.66Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 252.84H424.61V255.33H427.1V252.84Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 265.381H424.61V267.871H427.1V265.381Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 269.561H424.61V272.051H427.1V269.561Z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 240.311H420.65V242.801H423.14V240.311Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 244.49H420.65V246.98H423.14V244.49Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 248.66H420.65V251.15H423.14V248.66Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 252.84H420.65V255.33H423.14V252.84Z",
    fill: "#F0F0F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 257.02H420.65V259.51H423.14V257.02Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 265.381H420.65V267.871H423.14V265.381Z",
    fill: "#F0F0F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 269.561H420.65V272.051H423.14V269.561Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 223.59H416.69V226.08H419.18V223.59Z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 227.77H416.69V230.26H419.18V227.77Z",
    fill: "#F0F0F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 231.949H416.69V234.439H419.18V231.949Z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 236.131H416.69V238.621H419.18V236.131Z",
    fill: "#F0F0F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 240.311H416.69V242.801H419.18V240.311Z",
    fill: "#F0F0F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 244.49H416.69V246.98H419.18V244.49Z",
    fill: "#F0F0F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 248.66H416.69V251.15H419.18V248.66Z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 252.84H416.69V255.33H419.18V252.84Z",
    fill: "#F0F0F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 257.02H416.69V259.51H419.18V257.02Z",
    fill: "#F0F0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 261.199H416.69V263.689H419.18V261.199Z",
    fill: "#F0F0F0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18 269.561H416.69V272.051H419.18V269.561Z",
    fill: "#F0F0F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 223.59H412.73V226.08H415.22V223.59Z",
    fill: "#F0F0F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 227.77H412.73V230.26H415.22V227.77Z",
    fill: "#F0F0F0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 231.949H412.73V234.439H415.22V231.949Z",
    fill: "#F0F0F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 236.131H412.73V238.621H415.22V236.131Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 240.311H412.73V242.801H415.22V240.311Z",
    fill: "#F0F0F0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 244.49H412.73V246.98H415.22V244.49Z",
    fill: "#F0F0F0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 248.66H412.73V251.15H415.22V248.66Z",
    fill: "#F0F0F0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M415.22 286.279H412.73V288.769H415.22V286.279Z",
    fill: "#F0F0F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 223.59H408.77V226.08H411.26V223.59Z",
    fill: "#F0F0F0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 227.77H408.77V230.26H411.26V227.77Z",
    fill: "#F0F0F0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 231.949H408.77V234.439H411.26V231.949Z",
    fill: "#F0F0F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 236.131H408.77V238.621H411.26V236.131Z",
    fill: "#F0F0F0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 240.311H408.77V242.801H411.26V240.311Z",
    fill: "#F0F0F0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 244.49H408.77V246.98H411.26V244.49Z",
    fill: "#F0F0F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 248.66H408.77V251.15H411.26V248.66Z",
    fill: "#F0F0F0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 252.84H408.77V255.33H411.26V252.84Z",
    fill: "#F0F0F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 277.92H408.77V280.41H411.26V277.92Z",
    fill: "#F0F0F0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 282.1H408.77V284.59H411.26V282.1Z",
    fill: "#F0F0F0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 286.279H408.77V288.769H411.26V286.279Z",
    fill: "#F0F0F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 290.449H408.77V292.939H411.26V290.449Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 307.17H408.77V309.66H411.26V307.17Z",
    fill: "#F0F0F0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 223.59H404.81V226.08H407.3V223.59Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 227.77H404.81V230.26H407.3V227.77Z",
    fill: "#F0F0F0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 231.949H404.81V234.439H407.3V231.949Z",
    fill: "#F0F0F0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 236.131H404.81V238.621H407.3V236.131Z",
    fill: "#F0F0F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 240.311H404.81V242.801H407.3V240.311Z",
    fill: "#F0F0F0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 244.49H404.81V246.98H407.3V244.49Z",
    fill: "#F0F0F0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 248.66H404.81V251.15H407.3V248.66Z",
    fill: "#F0F0F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 252.84H404.81V255.33H407.3V252.84Z",
    fill: "#F0F0F0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 257.02H404.81V259.51H407.3V257.02Z",
    fill: "#F0F0F0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 261.199H404.81V263.689H407.3V261.199Z",
    fill: "#F0F0F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 273.74H404.81V276.23H407.3V273.74Z",
    fill: "#F0F0F0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 277.92H404.81V280.41H407.3V277.92Z",
    fill: "#F0F0F0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 282.1H404.81V284.59H407.3V282.1Z",
    fill: "#F0F0F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 286.279H404.81V288.769H407.3V286.279Z",
    fill: "#F0F0F0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 290.449H404.81V292.939H407.3V290.449Z",
    fill: "#F0F0F0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M407.3 307.17H404.81V309.66H407.3V307.17Z",
    fill: "#F0F0F0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 223.59H400.85V226.08H403.34V223.59Z",
    fill: "#F0F0F0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 227.77H400.85V230.26H403.34V227.77Z",
    fill: "#F0F0F0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 231.949H400.85V234.439H403.34V231.949Z",
    fill: "#F0F0F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 236.131H400.85V238.621H403.34V236.131Z",
    fill: "#F0F0F0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 240.311H400.85V242.801H403.34V240.311Z",
    fill: "#F0F0F0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 244.49H400.85V246.98H403.34V244.49Z",
    fill: "#F0F0F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 248.66H400.85V251.15H403.34V248.66Z",
    fill: "#F0F0F0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 252.84H400.85V255.33H403.34V252.84Z",
    fill: "#F0F0F0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 257.02H400.85V259.51H403.34V257.02Z",
    fill: "#F0F0F0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 261.199H400.85V263.689H403.34V261.199Z",
    fill: "#F0F0F0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 265.381H400.85V267.871H403.34V265.381Z",
    fill: "#F0F0F0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 269.561H400.85V272.051H403.34V269.561Z",
    fill: "#F0F0F0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 273.74H400.85V276.23H403.34V273.74Z",
    fill: "#F0F0F0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 277.92H400.85V280.41H403.34V277.92Z",
    fill: "#F0F0F0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 282.1H400.85V284.59H403.34V282.1Z",
    fill: "#F0F0F0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 286.279H400.85V288.769H403.34V286.279Z",
    fill: "#F0F0F0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 290.449H400.85V292.939H403.34V290.449Z",
    fill: "#F0F0F0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M403.34 294.631H400.85V297.121H403.34V294.631Z",
    fill: "#F0F0F0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 223.59H396.89V226.08H399.38V223.59Z",
    fill: "#F0F0F0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 227.77H396.89V230.26H399.38V227.77Z",
    fill: "#F0F0F0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 231.949H396.89V234.439H399.38V231.949Z",
    fill: "#F0F0F0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 236.131H396.89V238.621H399.38V236.131Z",
    fill: "#F0F0F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 240.311H396.89V242.801H399.38V240.311Z",
    fill: "#F0F0F0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 244.49H396.89V246.98H399.38V244.49Z",
    fill: "#F0F0F0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 248.66H396.89V251.15H399.38V248.66Z",
    fill: "#F0F0F0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 252.84H396.89V255.33H399.38V252.84Z",
    fill: "#F0F0F0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 257.02H396.89V259.51H399.38V257.02Z",
    fill: "#F0F0F0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 261.199H396.89V263.689H399.38V261.199Z",
    fill: "#F0F0F0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 273.74H396.89V276.23H399.38V273.74Z",
    fill: "#F0F0F0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 277.92H396.89V280.41H399.38V277.92Z",
    fill: "#F0F0F0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 282.1H396.89V284.59H399.38V282.1Z",
    fill: "#F0F0F0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M399.38 286.279H396.89V288.769H399.38V286.279Z",
    fill: "#F0F0F0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 223.59H392.94V226.08H395.43V223.59Z",
    fill: "#F0F0F0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 227.77H392.94V230.26H395.43V227.77Z",
    fill: "#F0F0F0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 231.949H392.94V234.439H395.43V231.949Z",
    fill: "#F0F0F0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 236.131H392.94V238.621H395.43V236.131Z",
    fill: "#F0F0F0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 240.311H392.94V242.801H395.43V240.311Z",
    fill: "#F0F0F0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 244.49H392.94V246.98H395.43V244.49Z",
    fill: "#F0F0F0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 248.66H392.94V251.15H395.43V248.66Z",
    fill: "#F0F0F0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 252.84H392.94V255.33H395.43V252.84Z",
    fill: "#F0F0F0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 257.02H392.94V259.51H395.43V257.02Z",
    fill: "#F0F0F0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 261.199H392.94V263.689H395.43V261.199Z",
    fill: "#F0F0F0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 273.74H392.94V276.23H395.43V273.74Z",
    fill: "#F0F0F0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 277.92H392.94V280.41H395.43V277.92Z",
    fill: "#F0F0F0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43 282.1H392.94V284.59H395.43V282.1Z",
    fill: "#F0F0F0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 212.74H348.36V215.23H350.85V212.74Z",
    fill: "#F0F0F0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 216.92H348.36V219.41H350.85V216.92Z",
    fill: "#F0F0F0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 221.1H348.36V223.59H350.85V221.1Z",
    fill: "#F0F0F0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 225.279H348.36V227.769H350.85V225.279Z",
    fill: "#F0F0F0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 229.461H348.36V231.951H350.85V229.461Z",
    fill: "#F0F0F0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 233.641H348.36V236.131H350.85V233.641Z",
    fill: "#F0F0F0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 237.811H348.36V240.301H350.85V237.811Z",
    fill: "#F0F0F0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 241.99H348.36V244.48H350.85V241.99Z",
    fill: "#F0F0F0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 254.529H348.36V257.019H350.85V254.529Z",
    fill: "#F0F0F0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M350.85 258.711H348.36V261.201H350.85V258.711Z",
    fill: "#F0F0F0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 212.74H344.4V215.23H346.89V212.74Z",
    fill: "#F0F0F0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 216.92H344.4V219.41H346.89V216.92Z",
    fill: "#F0F0F0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 221.1H344.4V223.59H346.89V221.1Z",
    fill: "#F0F0F0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 225.279H344.4V227.769H346.89V225.279Z",
    fill: "#F0F0F0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 229.461H344.4V231.951H346.89V229.461Z",
    fill: "#F0F0F0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 233.641H344.4V236.131H346.89V233.641Z",
    fill: "#F0F0F0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 237.811H344.4V240.301H346.89V237.811Z",
    fill: "#F0F0F0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 241.99H344.4V244.48H346.89V241.99Z",
    fill: "#F0F0F0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M346.89 258.711H344.4V261.201H346.89V258.711Z",
    fill: "#F0F0F0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 212.74H340.44V215.23H342.93V212.74Z",
    fill: "#F0F0F0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 216.92H340.44V219.41H342.93V216.92Z",
    fill: "#F0F0F0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 221.1H340.44V223.59H342.93V221.1Z",
    fill: "#F0F0F0"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 225.279H340.44V227.769H342.93V225.279Z",
    fill: "#F0F0F0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 229.461H340.44V231.951H342.93V229.461Z",
    fill: "#F0F0F0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 233.641H340.44V236.131H342.93V233.641Z",
    fill: "#F0F0F0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 237.811H340.44V240.301H342.93V237.811Z",
    fill: "#F0F0F0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M342.93 241.99H340.44V244.48H342.93V241.99Z",
    fill: "#F0F0F0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 212.74H336.48V215.23H338.97V212.74Z",
    fill: "#F0F0F0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 216.92H336.48V219.41H338.97V216.92Z",
    fill: "#F0F0F0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 221.1H336.48V223.59H338.97V221.1Z",
    fill: "#F0F0F0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 225.279H336.48V227.769H338.97V225.279Z",
    fill: "#F0F0F0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 229.461H336.48V231.951H338.97V229.461Z",
    fill: "#F0F0F0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 233.641H336.48V236.131H338.97V233.641Z",
    fill: "#F0F0F0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 241.99H336.48V244.48H338.97V241.99Z",
    fill: "#F0F0F0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 246.17H336.48V248.66H338.97V246.17Z",
    fill: "#F0F0F0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 258.711H336.48V261.201H338.97V258.711Z",
    fill: "#F0F0F0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 262.891H336.48V265.381H338.97V262.891Z",
    fill: "#F0F0F0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 267.07H336.48V269.56H338.97V267.07Z",
    fill: "#F0F0F0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 271.25H336.48V273.74H338.97V271.25Z",
    fill: "#F0F0F0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 275.43H336.48V277.92H338.97V275.43Z",
    fill: "#F0F0F0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 279.6H336.48V282.09H338.97V279.6Z",
    fill: "#F0F0F0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M338.97 283.779H336.48V286.269H338.97V283.779Z",
    fill: "#F0F0F0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 212.74H332.52V215.23H335.01V212.74Z",
    fill: "#F0F0F0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 216.92H332.52V219.41H335.01V216.92Z",
    fill: "#F0F0F0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 221.1H332.52V223.59H335.01V221.1Z",
    fill: "#F0F0F0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 225.279H332.52V227.769H335.01V225.279Z",
    fill: "#F0F0F0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 229.461H332.52V231.951H335.01V229.461Z",
    fill: "#F0F0F0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 233.641H332.52V236.131H335.01V233.641Z",
    fill: "#F0F0F0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 246.17H332.52V248.66H335.01V246.17Z",
    fill: "#F0F0F0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 250.35H332.52V252.84H335.01V250.35Z",
    fill: "#F0F0F0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 254.529H332.52V257.019H335.01V254.529Z",
    fill: "#F0F0F0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 258.711H332.52V261.201H335.01V258.711Z",
    fill: "#F0F0F0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 262.891H332.52V265.381H335.01V262.891Z",
    fill: "#F0F0F0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 267.07H332.52V269.56H335.01V267.07Z",
    fill: "#F0F0F0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 271.25H332.52V273.74H335.01V271.25Z",
    fill: "#F0F0F0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 275.43H332.52V277.92H335.01V275.43Z",
    fill: "#F0F0F0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 279.6H332.52V282.09H335.01V279.6Z",
    fill: "#F0F0F0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 283.779H332.52V286.269H335.01V283.779Z",
    fill: "#F0F0F0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 287.961H332.52V290.451H335.01V287.961Z",
    fill: "#F0F0F0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 296.32H332.52V298.81H335.01V296.32Z",
    fill: "#F0F0F0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 212.74H328.56V215.23H331.05V212.74Z",
    fill: "#F0F0F0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 216.92H328.56V219.41H331.05V216.92Z",
    fill: "#F0F0F0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 221.1H328.56V223.59H331.05V221.1Z",
    fill: "#F0F0F0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 225.279H328.56V227.769H331.05V225.279Z",
    fill: "#F0F0F0"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 229.461H328.56V231.951H331.05V229.461Z",
    fill: "#F0F0F0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 233.641H328.56V236.131H331.05V233.641Z",
    fill: "#F0F0F0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 246.17H328.56V248.66H331.05V246.17Z",
    fill: "#F0F0F0"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 250.35H328.56V252.84H331.05V250.35Z",
    fill: "#F0F0F0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 254.529H328.56V257.019H331.05V254.529Z",
    fill: "#F0F0F0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 258.711H328.56V261.201H331.05V258.711Z",
    fill: "#F0F0F0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 271.25H328.56V273.74H331.05V271.25Z",
    fill: "#F0F0F0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 275.43H328.56V277.92H331.05V275.43Z",
    fill: "#F0F0F0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 279.6H328.56V282.09H331.05V279.6Z",
    fill: "#F0F0F0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 283.779H328.56V286.269H331.05V283.779Z",
    fill: "#F0F0F0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 287.961H328.56V290.451H331.05V287.961Z",
    fill: "#F0F0F0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 296.32H328.56V298.81H331.05V296.32Z",
    fill: "#F0F0F0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M331.05 300.5H328.56V302.99H331.05V300.5Z",
    fill: "#F0F0F0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 251.6H292.64V254.09H295.13V251.6Z",
    fill: "#F0F0F0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 255.779H292.64V258.269H295.13V255.779Z",
    fill: "#F0F0F0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 259.961H292.64V262.451H295.13V259.961Z",
    fill: "#F0F0F0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 264.131H292.64V266.621H295.13V264.131Z",
    fill: "#F0F0F0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 268.311H292.64V270.801H295.13V268.311Z",
    fill: "#F0F0F0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 272.49H292.64V274.98H295.13V272.49Z",
    fill: "#F0F0F0"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 276.67H292.64V279.16H295.13V276.67Z",
    fill: "#F0F0F0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 289.211H292.64V291.701H295.13V289.211Z",
    fill: "#F0F0F0"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 293.391H292.64V295.881H295.13V293.391Z",
    fill: "#F0F0F0"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M295.13 297.57H292.64V300.06H295.13V297.57Z",
    fill: "#F0F0F0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 251.6H288.68V254.09H291.17V251.6Z",
    fill: "#F0F0F0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 255.779H288.68V258.269H291.17V255.779Z",
    fill: "#F0F0F0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 259.961H288.68V262.451H291.17V259.961Z",
    fill: "#F0F0F0"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 264.131H288.68V266.621H291.17V264.131Z",
    fill: "#F0F0F0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 268.311H288.68V270.801H291.17V268.311Z",
    fill: "#F0F0F0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 272.49H288.68V274.98H291.17V272.49Z",
    fill: "#F0F0F0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 276.67H288.68V279.16H291.17V276.67Z",
    fill: "#F0F0F0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 251.6H284.72V254.09H287.21V251.6Z",
    fill: "#F0F0F0"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 255.779H284.72V258.269H287.21V255.779Z",
    fill: "#F0F0F0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 259.961H284.72V262.451H287.21V259.961Z",
    fill: "#F0F0F0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 264.131H284.72V266.621H287.21V264.131Z",
    fill: "#F0F0F0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 268.311H284.72V270.801H287.21V268.311Z",
    fill: "#F0F0F0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 272.49H284.72V274.98H287.21V272.49Z",
    fill: "#F0F0F0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 276.67H284.72V279.16H287.21V276.67Z",
    fill: "#F0F0F0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 251.6H280.76V254.09H283.25V251.6Z",
    fill: "#F0F0F0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 255.779H280.76V258.269H283.25V255.779Z",
    fill: "#F0F0F0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 259.961H280.76V262.451H283.25V259.961Z",
    fill: "#F0F0F0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 264.131H280.76V266.621H283.25V264.131Z",
    fill: "#F0F0F0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 268.311H280.76V270.801H283.25V268.311Z",
    fill: "#F0F0F0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 272.49H280.76V274.98H283.25V272.49Z",
    fill: "#F0F0F0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 276.67H280.76V279.16H283.25V276.67Z",
    fill: "#F0F0F0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 280.85H280.76V283.34H283.25V280.85Z",
    fill: "#F0F0F0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 285.029H280.76V287.519H283.25V285.029Z",
    fill: "#F0F0F0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 289.211H280.76V291.701H283.25V289.211Z",
    fill: "#F0F0F0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 293.391H280.76V295.881H283.25V293.391Z",
    fill: "#F0F0F0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 251.6H276.8V254.09H279.29V251.6Z",
    fill: "#F0F0F0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 255.779H276.8V258.269H279.29V255.779Z",
    fill: "#F0F0F0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 259.961H276.8V262.451H279.29V259.961Z",
    fill: "#F0F0F0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 264.131H276.8V266.621H279.29V264.131Z",
    fill: "#F0F0F0"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 268.311H276.8V270.801H279.29V268.311Z",
    fill: "#F0F0F0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 272.49H276.8V274.98H279.29V272.49Z",
    fill: "#F0F0F0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 276.67H276.8V279.16H279.29V276.67Z",
    fill: "#F0F0F0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 280.85H276.8V283.34H279.29V280.85Z",
    fill: "#F0F0F0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 285.029H276.8V287.519H279.29V285.029Z",
    fill: "#F0F0F0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 289.211H276.8V291.701H279.29V289.211Z",
    fill: "#F0F0F0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 293.391H276.8V295.881H279.29V293.391Z",
    fill: "#F0F0F0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 297.57H276.8V300.06H279.29V297.57Z",
    fill: "#F0F0F0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 310.1H276.8V312.59H279.29V310.1Z",
    fill: "#F0F0F0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M279.29 314.279H276.8V316.769H279.29V314.279Z",
    fill: "#F0F0F0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 251.6H272.84V254.09H275.33V251.6Z",
    fill: "#F0F0F0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 255.779H272.84V258.269H275.33V255.779Z",
    fill: "#F0F0F0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 259.961H272.84V262.451H275.33V259.961Z",
    fill: "#F0F0F0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 272.49H272.84V274.98H275.33V272.49Z",
    fill: "#F0F0F0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 276.67H272.84V279.16H275.33V276.67Z",
    fill: "#F0F0F0"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 280.85H272.84V283.34H275.33V280.85Z",
    fill: "#F0F0F0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 285.029H272.84V287.519H275.33V285.029Z",
    fill: "#F0F0F0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 289.211H272.84V291.701H275.33V289.211Z",
    fill: "#F0F0F0"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 293.391H272.84V295.881H275.33V293.391Z",
    fill: "#F0F0F0"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 297.57H272.84V300.06H275.33V297.57Z",
    fill: "#F0F0F0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 310.1H272.84V312.59H275.33V310.1Z",
    fill: "#F0F0F0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 314.279H272.84V316.769H275.33V314.279Z",
    fill: "#F0F0F0"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 318.461H272.84V320.951H275.33V318.461Z",
    fill: "#F0F0F0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 226.52H231.35V229.01H233.84V226.52Z",
    fill: "#F0F0F0"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 230.699H231.35V233.189H233.84V230.699Z",
    fill: "#F0F0F0"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 234.881H231.35V237.371H233.84V234.881Z",
    fill: "#F0F0F0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 239.061H231.35V241.551H233.84V239.061Z",
    fill: "#F0F0F0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 243.24H231.35V245.73H233.84V243.24Z",
    fill: "#F0F0F0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 247.42H231.35V249.91H233.84V247.42Z",
    fill: "#F0F0F0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 251.6H231.35V254.09H233.84V251.6Z",
    fill: "#F0F0F0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 255.779H231.35V258.269H233.84V255.779Z",
    fill: "#F0F0F0"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 259.961H231.35V262.451H233.84V259.961Z",
    fill: "#F0F0F0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 264.131H231.35V266.621H233.84V264.131Z",
    fill: "#F0F0F0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 268.311H231.35V270.801H233.84V268.311Z",
    fill: "#F0F0F0"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 272.49H231.35V274.98H233.84V272.49Z",
    fill: "#F0F0F0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 276.67H231.35V279.16H233.84V276.67Z",
    fill: "#F0F0F0"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 280.85H231.35V283.34H233.84V280.85Z",
    fill: "#F0F0F0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 285.029H231.35V287.519H233.84V285.029Z",
    fill: "#F0F0F0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 289.211H231.35V291.701H233.84V289.211Z",
    fill: "#F0F0F0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 293.391H231.35V295.881H233.84V293.391Z",
    fill: "#F0F0F0"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 297.57H231.35V300.06H233.84V297.57Z",
    fill: "#F0F0F0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 301.75H231.35V304.24H233.84V301.75Z",
    fill: "#F0F0F0"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 305.92H231.35V308.41H233.84V305.92Z",
    fill: "#F0F0F0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 310.1H231.35V312.59H233.84V310.1Z",
    fill: "#F0F0F0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 314.279H231.35V316.769H233.84V314.279Z",
    fill: "#F0F0F0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 318.461H231.35V320.951H233.84V318.461Z",
    fill: "#F0F0F0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 226.52H227.39V229.01H229.88V226.52Z",
    fill: "#F0F0F0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 230.699H227.39V233.189H229.88V230.699Z",
    fill: "#F0F0F0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 234.881H227.39V237.371H229.88V234.881Z",
    fill: "#F0F0F0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 239.061H227.39V241.551H229.88V239.061Z",
    fill: "#F0F0F0"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 243.24H227.39V245.73H229.88V243.24Z",
    fill: "#F0F0F0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 247.42H227.39V249.91H229.88V247.42Z",
    fill: "#F0F0F0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 251.6H227.39V254.09H229.88V251.6Z",
    fill: "#F0F0F0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 255.779H227.39V258.269H229.88V255.779Z",
    fill: "#F0F0F0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 259.961H227.39V262.451H229.88V259.961Z",
    fill: "#F0F0F0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 264.131H227.39V266.621H229.88V264.131Z",
    fill: "#F0F0F0"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 268.311H227.39V270.801H229.88V268.311Z",
    fill: "#F0F0F0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 272.49H227.39V274.98H229.88V272.49Z",
    fill: "#F0F0F0"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 276.67H227.39V279.16H229.88V276.67Z",
    fill: "#F0F0F0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 280.85H227.39V283.34H229.88V280.85Z",
    fill: "#F0F0F0"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 285.029H227.39V287.519H229.88V285.029Z",
    fill: "#F0F0F0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 289.211H227.39V291.701H229.88V289.211Z",
    fill: "#F0F0F0"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 293.391H227.39V295.881H229.88V293.391Z",
    fill: "#F0F0F0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 297.57H227.39V300.06H229.88V297.57Z",
    fill: "#F0F0F0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 301.75H227.39V304.24H229.88V301.75Z",
    fill: "#F0F0F0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 226.52H223.43V229.01H225.92V226.52Z",
    fill: "#F0F0F0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 230.699H223.43V233.189H225.92V230.699Z",
    fill: "#F0F0F0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 234.881H223.43V237.371H225.92V234.881Z",
    fill: "#F0F0F0"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 239.061H223.43V241.551H225.92V239.061Z",
    fill: "#F0F0F0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 243.24H223.43V245.73H225.92V243.24Z",
    fill: "#F0F0F0"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 247.42H223.43V249.91H225.92V247.42Z",
    fill: "#F0F0F0"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 251.6H223.43V254.09H225.92V251.6Z",
    fill: "#F0F0F0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 255.779H223.43V258.269H225.92V255.779Z",
    fill: "#F0F0F0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 259.961H223.43V262.451H225.92V259.961Z",
    fill: "#F0F0F0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 264.131H223.43V266.621H225.92V264.131Z",
    fill: "#F0F0F0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 268.311H223.43V270.801H225.92V268.311Z",
    fill: "#F0F0F0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 272.49H223.43V274.98H225.92V272.49Z",
    fill: "#F0F0F0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 276.67H223.43V279.16H225.92V276.67Z",
    fill: "#F0F0F0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 280.85H223.43V283.34H225.92V280.85Z",
    fill: "#F0F0F0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 285.029H223.43V287.519H225.92V285.029Z",
    fill: "#F0F0F0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 289.211H223.43V291.701H225.92V289.211Z",
    fill: "#F0F0F0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 293.391H223.43V295.881H225.92V293.391Z",
    fill: "#F0F0F0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 297.57H223.43V300.06H225.92V297.57Z",
    fill: "#F0F0F0"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M225.92 301.75H223.43V304.24H225.92V301.75Z",
    fill: "#F0F0F0"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 226.52H219.47V229.01H221.96V226.52Z",
    fill: "#F0F0F0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 230.699H219.47V233.189H221.96V230.699Z",
    fill: "#F0F0F0"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 234.881H219.47V237.371H221.96V234.881Z",
    fill: "#F0F0F0"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 239.061H219.47V241.551H221.96V239.061Z",
    fill: "#F0F0F0"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 243.24H219.47V245.73H221.96V243.24Z",
    fill: "#F0F0F0"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 247.42H219.47V249.91H221.96V247.42Z",
    fill: "#F0F0F0"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 251.6H219.47V254.09H221.96V251.6Z",
    fill: "#F0F0F0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 255.779H219.47V258.269H221.96V255.779Z",
    fill: "#F0F0F0"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 259.961H219.47V262.451H221.96V259.961Z",
    fill: "#F0F0F0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 264.131H219.47V266.621H221.96V264.131Z",
    fill: "#F0F0F0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 268.311H219.47V270.801H221.96V268.311Z",
    fill: "#F0F0F0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 272.49H219.47V274.98H221.96V272.49Z",
    fill: "#F0F0F0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 276.67H219.47V279.16H221.96V276.67Z",
    fill: "#F0F0F0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 280.85H219.47V283.34H221.96V280.85Z",
    fill: "#F0F0F0"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M221.96 285.029H219.47V287.519H221.96V285.029Z",
    fill: "#F0F0F0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M218 226.52H215.51V229.01H218V226.52Z",
    fill: "#F0F0F0"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M218 230.699H215.51V233.189H218V230.699Z",
    fill: "#F0F0F0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M218 234.881H215.51V237.371H218V234.881Z",
    fill: "#F0F0F0"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M218 239.061H215.51V241.551H218V239.061Z",
    fill: "#F0F0F0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M218 243.24H215.51V245.73H218V243.24Z",
    fill: "#F0F0F0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M218 247.42H215.51V249.91H218V247.42Z",
    fill: "#F0F0F0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M218 251.6H215.51V254.09H218V251.6Z",
    fill: "#F0F0F0"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M218 255.779H215.51V258.269H218V255.779Z",
    fill: "#F0F0F0"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M218 259.961H215.51V262.451H218V259.961Z",
    fill: "#F0F0F0"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M218 264.131H215.51V266.621H218V264.131Z",
    fill: "#F0F0F0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M218 268.311H215.51V270.801H218V268.311Z",
    fill: "#F0F0F0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M218 272.49H215.51V274.98H218V272.49Z",
    fill: "#F0F0F0"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M218 276.67H215.51V279.16H218V276.67Z",
    fill: "#F0F0F0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 226.52H211.55V229.01H214.04V226.52Z",
    fill: "#F0F0F0"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 230.699H211.55V233.189H214.04V230.699Z",
    fill: "#F0F0F0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 234.881H211.55V237.371H214.04V234.881Z",
    fill: "#F0F0F0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 239.061H211.55V241.551H214.04V239.061Z",
    fill: "#F0F0F0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 243.24H211.55V245.73H214.04V243.24Z",
    fill: "#F0F0F0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 247.42H211.55V249.91H214.04V247.42Z",
    fill: "#F0F0F0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 251.6H211.55V254.09H214.04V251.6Z",
    fill: "#F0F0F0"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 255.779H211.55V258.269H214.04V255.779Z",
    fill: "#F0F0F0"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 259.961H211.55V262.451H214.04V259.961Z",
    fill: "#F0F0F0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 264.131H211.55V266.621H214.04V264.131Z",
    fill: "#F0F0F0"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 268.311H211.55V270.801H214.04V268.311Z",
    fill: "#F0F0F0"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 272.49H211.55V274.98H214.04V272.49Z",
    fill: "#F0F0F0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 225.279H442.64V227.769H445.13V225.279Z",
    fill: "#F0F0F0"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 229.461H442.64V231.951H445.13V229.461Z",
    fill: "#F0F0F0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 233.641H442.64V236.131H445.13V233.641Z",
    fill: "#F0F0F0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 237.811H442.64V240.301H445.13V237.811Z",
    fill: "#F0F0F0"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 241.99H442.64V244.48H445.13V241.99Z",
    fill: "#F0F0F0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 246.17H442.64V248.66H445.13V246.17Z",
    fill: "#F0F0F0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 250.35H442.64V252.84H445.13V250.35Z",
    fill: "#F0F0F0"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 254.529H442.64V257.019H445.13V254.529Z",
    fill: "#F0F0F0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 258.711H442.64V261.201H445.13V258.711Z",
    fill: "#F0F0F0"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 262.891H442.64V265.381H445.13V262.891Z",
    fill: "#F0F0F0"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 267.07H442.64V269.56H445.13V267.07Z",
    fill: "#F0F0F0"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 271.25H442.64V273.74H445.13V271.25Z",
    fill: "#F0F0F0"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 275.43H442.64V277.92H445.13V275.43Z",
    fill: "#F0F0F0"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 279.6H442.64V282.09H445.13V279.6Z",
    fill: "#F0F0F0"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 283.779H442.64V286.269H445.13V283.779Z",
    fill: "#F0F0F0"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 287.961H442.64V290.451H445.13V287.961Z",
    fill: "#F0F0F0"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 292.141H442.64V294.631H445.13V292.141Z",
    fill: "#F0F0F0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 300.5H442.64V302.99H445.13V300.5Z",
    fill: "#F0F0F0"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 304.68H442.64V307.17H445.13V304.68Z",
    fill: "#F0F0F0"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 308.859H442.64V311.349H445.13V308.859Z",
    fill: "#F0F0F0"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 313.039H442.64V315.529H445.13V313.039Z",
    fill: "#F0F0F0"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 317.211H442.64V319.701H445.13V317.211Z",
    fill: "#F0F0F0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 225.279H438.68V227.769H441.17V225.279Z",
    fill: "#F0F0F0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 229.461H438.68V231.951H441.17V229.461Z",
    fill: "#F0F0F0"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 233.641H438.68V236.131H441.17V233.641Z",
    fill: "#F0F0F0"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 237.811H438.68V240.301H441.17V237.811Z",
    fill: "#F0F0F0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 241.99H438.68V244.48H441.17V241.99Z",
    fill: "#F0F0F0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 246.17H438.68V248.66H441.17V246.17Z",
    fill: "#F0F0F0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 250.35H438.68V252.84H441.17V250.35Z",
    fill: "#F0F0F0"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 254.529H438.68V257.019H441.17V254.529Z",
    fill: "#F0F0F0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 258.711H438.68V261.201H441.17V258.711Z",
    fill: "#F0F0F0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 262.891H438.68V265.381H441.17V262.891Z",
    fill: "#F0F0F0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 267.07H438.68V269.56H441.17V267.07Z",
    fill: "#F0F0F0"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 271.25H438.68V273.74H441.17V271.25Z",
    fill: "#F0F0F0"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 275.43H438.68V277.92H441.17V275.43Z",
    fill: "#F0F0F0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 279.6H438.68V282.09H441.17V279.6Z",
    fill: "#F0F0F0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 283.779H438.68V286.269H441.17V283.779Z",
    fill: "#F0F0F0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 287.961H438.68V290.451H441.17V287.961Z",
    fill: "#F0F0F0"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 313.039H438.68V315.529H441.17V313.039Z",
    fill: "#F0F0F0"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M441.17 317.211H438.68V319.701H441.17V317.211Z",
    fill: "#F0F0F0"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 225.279H434.73V227.769H437.22V225.279Z",
    fill: "#F0F0F0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 229.461H434.73V231.951H437.22V229.461Z",
    fill: "#F0F0F0"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 233.641H434.73V236.131H437.22V233.641Z",
    fill: "#F0F0F0"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 237.811H434.73V240.301H437.22V237.811Z",
    fill: "#F0F0F0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 241.99H434.73V244.48H437.22V241.99Z",
    fill: "#F0F0F0"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 246.17H434.73V248.66H437.22V246.17Z",
    fill: "#F0F0F0"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 250.35H434.73V252.84H437.22V250.35Z",
    fill: "#F0F0F0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 254.529H434.73V257.019H437.22V254.529Z",
    fill: "#F0F0F0"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 258.711H434.73V261.201H437.22V258.711Z",
    fill: "#F0F0F0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 262.891H434.73V265.381H437.22V262.891Z",
    fill: "#F0F0F0"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 267.07H434.73V269.56H437.22V267.07Z",
    fill: "#F0F0F0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 271.25H434.73V273.74H437.22V271.25Z",
    fill: "#F0F0F0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 275.43H434.73V277.92H437.22V275.43Z",
    fill: "#F0F0F0"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 279.6H434.73V282.09H437.22V279.6Z",
    fill: "#F0F0F0"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 283.779H434.73V286.269H437.22V283.779Z",
    fill: "#F0F0F0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 287.961H434.73V290.451H437.22V287.961Z",
    fill: "#F0F0F0"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 296.32H434.73V298.81H437.22V296.32Z",
    fill: "#F0F0F0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 300.5H434.73V302.99H437.22V300.5Z",
    fill: "#F0F0F0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 304.68H434.73V307.17H437.22V304.68Z",
    fill: "#F0F0F0"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 308.859H434.73V311.349H437.22V308.859Z",
    fill: "#F0F0F0"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M437.22 317.211H434.73V319.701H437.22V317.211Z",
    fill: "#F0F0F0"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 254.529H365.66V257.019H368.15V254.529Z",
    fill: "#F0F0F0"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 258.711H365.66V261.201H368.15V258.711Z",
    fill: "#F0F0F0"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 262.891H365.66V265.381H368.15V262.891Z",
    fill: "#F0F0F0"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 267.07H365.66V269.56H368.15V267.07Z",
    fill: "#F0F0F0"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 271.25H365.66V273.74H368.15V271.25Z",
    fill: "#F0F0F0"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 275.43H365.66V277.92H368.15V275.43Z",
    fill: "#F0F0F0"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 279.6H365.66V282.09H368.15V279.6Z",
    fill: "#F0F0F0"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 283.779H365.66V286.269H368.15V283.779Z",
    fill: "#F0F0F0"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 287.961H365.66V290.451H368.15V287.961Z",
    fill: "#F0F0F0"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 292.141H365.66V294.631H368.15V292.141Z",
    fill: "#F0F0F0"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 296.32H365.66V298.81H368.15V296.32Z",
    fill: "#F0F0F0"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 300.5H365.66V302.99H368.15V300.5Z",
    fill: "#F0F0F0"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 304.68H365.66V307.17H368.15V304.68Z",
    fill: "#F0F0F0"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 313.039H365.66V315.529H368.15V313.039Z",
    fill: "#F0F0F0"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 317.211H365.66V319.701H368.15V317.211Z",
    fill: "#F0F0F0"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 321.391H365.66V323.881H368.15V321.391Z",
    fill: "#F0F0F0"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 325.57H365.66V328.06H368.15V325.57Z",
    fill: "#F0F0F0"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 333.93H365.66V336.42H368.15V333.93Z",
    fill: "#F0F0F0"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 338.109H365.66V340.599H368.15V338.109Z",
    fill: "#F0F0F0"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 342.289H365.66V344.779H368.15V342.289Z",
    fill: "#F0F0F0"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 254.529H361.7V257.019H364.19V254.529Z",
    fill: "#F0F0F0"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 258.711H361.7V261.201H364.19V258.711Z",
    fill: "#F0F0F0"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 262.891H361.7V265.381H364.19V262.891Z",
    fill: "#F0F0F0"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 267.07H361.7V269.56H364.19V267.07Z",
    fill: "#F0F0F0"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 271.25H361.7V273.74H364.19V271.25Z",
    fill: "#F0F0F0"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 275.43H361.7V277.92H364.19V275.43Z",
    fill: "#F0F0F0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 279.6H361.7V282.09H364.19V279.6Z",
    fill: "#F0F0F0"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 283.779H361.7V286.269H364.19V283.779Z",
    fill: "#F0F0F0"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 287.961H361.7V290.451H364.19V287.961Z",
    fill: "#F0F0F0"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 292.141H361.7V294.631H364.19V292.141Z",
    fill: "#F0F0F0"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 296.32H361.7V298.81H364.19V296.32Z",
    fill: "#F0F0F0"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 300.5H361.7V302.99H364.19V300.5Z",
    fill: "#F0F0F0"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 304.68H361.7V307.17H364.19V304.68Z",
    fill: "#F0F0F0"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 317.211H361.7V319.701H364.19V317.211Z",
    fill: "#F0F0F0"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 321.391H361.7V323.881H364.19V321.391Z",
    fill: "#F0F0F0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 329.75H361.7V332.24H364.19V329.75Z",
    fill: "#F0F0F0"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 333.93H361.7V336.42H364.19V333.93Z",
    fill: "#F0F0F0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 338.109H361.7V340.599H364.19V338.109Z",
    fill: "#F0F0F0"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 342.289H361.7V344.779H364.19V342.289Z",
    fill: "#F0F0F0"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 254.529H357.74V257.019H360.23V254.529Z",
    fill: "#F0F0F0"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 258.711H357.74V261.201H360.23V258.711Z",
    fill: "#F0F0F0"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 262.891H357.74V265.381H360.23V262.891Z",
    fill: "#F0F0F0"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 267.07H357.74V269.56H360.23V267.07Z",
    fill: "#F0F0F0"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 271.25H357.74V273.74H360.23V271.25Z",
    fill: "#F0F0F0"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 275.43H357.74V277.92H360.23V275.43Z",
    fill: "#F0F0F0"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 279.6H357.74V282.09H360.23V279.6Z",
    fill: "#F0F0F0"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 283.779H357.74V286.269H360.23V283.779Z",
    fill: "#F0F0F0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 287.961H357.74V290.451H360.23V287.961Z",
    fill: "#F0F0F0"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 292.141H357.74V294.631H360.23V292.141Z",
    fill: "#F0F0F0"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 296.32H357.74V298.81H360.23V296.32Z",
    fill: "#F0F0F0"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 300.5H357.74V302.99H360.23V300.5Z",
    fill: "#F0F0F0"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 304.68H357.74V307.17H360.23V304.68Z",
    fill: "#F0F0F0"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 308.859H357.74V311.349H360.23V308.859Z",
    fill: "#F0F0F0"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 317.211H357.74V319.701H360.23V317.211Z",
    fill: "#F0F0F0"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 325.57H357.74V328.06H360.23V325.57Z",
    fill: "#F0F0F0"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 329.75H357.74V332.24H360.23V329.75Z",
    fill: "#F0F0F0"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 333.93H357.74V336.42H360.23V333.93Z",
    fill: "#F0F0F0"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 338.109H357.74V340.599H360.23V338.109Z",
    fill: "#F0F0F0"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23 342.289H357.74V344.779H360.23V342.289Z",
    fill: "#F0F0F0"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 278.359H381.79V280.849H384.28V278.359Z",
    fill: "#F0F0F0"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 282.539H381.79V285.029H384.28V282.539Z",
    fill: "#F0F0F0"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 286.721H381.79V289.211H384.28V286.721Z",
    fill: "#F0F0F0"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 290.891H381.79V293.381H384.28V290.891Z",
    fill: "#F0F0F0"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 295.07H381.79V297.56H384.28V295.07Z",
    fill: "#F0F0F0"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 299.25H381.79V301.74H384.28V299.25Z",
    fill: "#F0F0F0"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 311.789H381.79V314.279H384.28V311.789Z",
    fill: "#F0F0F0"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 315.971H381.79V318.461H384.28V315.971Z",
    fill: "#F0F0F0"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 320.15H381.79V322.64H384.28V320.15Z",
    fill: "#F0F0F0"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 324.33H381.79V326.82H384.28V324.33Z",
    fill: "#F0F0F0"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 328.51H381.79V331H384.28V328.51Z",
    fill: "#F0F0F0"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 332.68H381.79V335.17H384.28V332.68Z",
    fill: "#F0F0F0"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M384.28 336.859H381.79V339.349H384.28V336.859Z",
    fill: "#F0F0F0"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 278.359H377.83V280.849H380.32V278.359Z",
    fill: "#F0F0F0"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 282.539H377.83V285.029H380.32V282.539Z",
    fill: "#F0F0F0"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 286.721H377.83V289.211H380.32V286.721Z",
    fill: "#F0F0F0"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 290.891H377.83V293.381H380.32V290.891Z",
    fill: "#F0F0F0"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 295.07H377.83V297.56H380.32V295.07Z",
    fill: "#F0F0F0"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 299.25H377.83V301.74H380.32V299.25Z",
    fill: "#F0F0F0"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 311.789H377.83V314.279H380.32V311.789Z",
    fill: "#F0F0F0"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 315.971H377.83V318.461H380.32V315.971Z",
    fill: "#F0F0F0"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 320.15H377.83V322.64H380.32V320.15Z",
    fill: "#F0F0F0"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 324.33H377.83V326.82H380.32V324.33Z",
    fill: "#F0F0F0"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 328.51H377.83V331H380.32V328.51Z",
    fill: "#F0F0F0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 332.68H377.83V335.17H380.32V332.68Z",
    fill: "#F0F0F0"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M380.32 341.039H377.83V343.529H380.32V341.039Z",
    fill: "#F0F0F0"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 259.961H246.3V262.451H248.79V259.961Z",
    fill: "#F0F0F0"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 264.131H246.3V266.621H248.79V264.131Z",
    fill: "#F0F0F0"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 268.311H246.3V270.801H248.79V268.311Z",
    fill: "#F0F0F0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 272.49H246.3V274.98H248.79V272.49Z",
    fill: "#F0F0F0"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 276.67H246.3V279.16H248.79V276.67Z",
    fill: "#F0F0F0"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 280.85H246.3V283.34H248.79V280.85Z",
    fill: "#F0F0F0"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 285.029H246.3V287.519H248.79V285.029Z",
    fill: "#F0F0F0"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 289.211H246.3V291.701H248.79V289.211Z",
    fill: "#F0F0F0"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 293.391H246.3V295.881H248.79V293.391Z",
    fill: "#F0F0F0"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 297.57H246.3V300.06H248.79V297.57Z",
    fill: "#F0F0F0"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 301.75H246.3V304.24H248.79V301.75Z",
    fill: "#F0F0F0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 310.1H246.3V312.59H248.79V310.1Z",
    fill: "#F0F0F0"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 314.279H246.3V316.769H248.79V314.279Z",
    fill: "#F0F0F0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 318.461H246.3V320.951H248.79V318.461Z",
    fill: "#F0F0F0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 322.641H246.3V325.131H248.79V322.641Z",
    fill: "#F0F0F0"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 326.82H246.3V329.31H248.79V326.82Z",
    fill: "#F0F0F0"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 331H246.3V333.49H248.79V331Z",
    fill: "#F0F0F0"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 335.18H246.3V337.67H248.79V335.18Z",
    fill: "#F0F0F0"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M248.79 339.359H246.3V341.849H248.79V339.359Z",
    fill: "#F0F0F0"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 259.961H242.35V262.451H244.84V259.961Z",
    fill: "#F0F0F0"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 264.131H242.35V266.621H244.84V264.131Z",
    fill: "#F0F0F0"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 268.311H242.35V270.801H244.84V268.311Z",
    fill: "#F0F0F0"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 272.49H242.35V274.98H244.84V272.49Z",
    fill: "#F0F0F0"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 276.67H242.35V279.16H244.84V276.67Z",
    fill: "#F0F0F0"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 280.85H242.35V283.34H244.84V280.85Z",
    fill: "#F0F0F0"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 285.029H242.35V287.519H244.84V285.029Z",
    fill: "#F0F0F0"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 289.211H242.35V291.701H244.84V289.211Z",
    fill: "#F0F0F0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 293.391H242.35V295.881H244.84V293.391Z",
    fill: "#F0F0F0"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 297.57H242.35V300.06H244.84V297.57Z",
    fill: "#F0F0F0"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 301.75H242.35V304.24H244.84V301.75Z",
    fill: "#F0F0F0"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 305.92H242.35V308.41H244.84V305.92Z",
    fill: "#F0F0F0"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 310.1H242.35V312.59H244.84V310.1Z",
    fill: "#F0F0F0"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 314.279H242.35V316.769H244.84V314.279Z",
    fill: "#F0F0F0"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 318.461H242.35V320.951H244.84V318.461Z",
    fill: "#F0F0F0"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 322.641H242.35V325.131H244.84V322.641Z",
    fill: "#F0F0F0"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 326.82H242.35V329.31H244.84V326.82Z",
    fill: "#F0F0F0"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 331H242.35V333.49H244.84V331Z",
    fill: "#F0F0F0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 335.18H242.35V337.67H244.84V335.18Z",
    fill: "#F0F0F0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M244.84 339.359H242.35V341.849H244.84V339.359Z",
    fill: "#F0F0F0"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 276.23H265.81V278.72H268.3V276.23Z",
    fill: "#F0F0F0"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 280.41H265.81V282.9H268.3V280.41Z",
    fill: "#F0F0F0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 284.59H265.81V287.08H268.3V284.59Z",
    fill: "#F0F0F0"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 288.77H265.81V291.26H268.3V288.77Z",
    fill: "#F0F0F0"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 292.949H265.81V295.439H268.3V292.949Z",
    fill: "#F0F0F0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 297.131H265.81V299.621H268.3V297.131Z",
    fill: "#F0F0F0"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 301.311H265.81V303.801H268.3V301.311Z",
    fill: "#F0F0F0"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 305.48H265.81V307.97H268.3V305.48Z",
    fill: "#F0F0F0"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 309.66H265.81V312.15H268.3V309.66Z",
    fill: "#F0F0F0"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 313.84H265.81V316.33H268.3V313.84Z",
    fill: "#F0F0F0"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 276.23H261.85V278.72H264.34V276.23Z",
    fill: "#F0F0F0"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 280.41H261.85V282.9H264.34V280.41Z",
    fill: "#F0F0F0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 284.59H261.85V287.08H264.34V284.59Z",
    fill: "#F0F0F0"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 288.77H261.85V291.26H264.34V288.77Z",
    fill: "#F0F0F0"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 292.949H261.85V295.439H264.34V292.949Z",
    fill: "#F0F0F0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 297.131H261.85V299.621H264.34V297.131Z",
    fill: "#F0F0F0"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 301.311H261.85V303.801H264.34V301.311Z",
    fill: "#F0F0F0"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 305.48H261.85V307.97H264.34V305.48Z",
    fill: "#F0F0F0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M264.34 309.66H261.85V312.15H264.34V309.66Z",
    fill: "#F0F0F0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M287.89 117.641H283.71V350.721H287.89V117.641Z",
    fill: "#E0E0E0"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M366.6 117.641H362.42V350.721H366.6V117.641Z",
    fill: "#E0E0E0"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M445.3 117.641H441.12V350.721H445.3V117.641Z",
    fill: "#E0E0E0"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M147.82 328H173.6C174.77 328 175.891 328.465 176.718 329.292C177.545 330.119 178.01 331.24 178.01 332.41V382.24H143.42V332.45C143.415 331.868 143.525 331.291 143.743 330.752C143.962 330.213 144.285 329.723 144.694 329.309C145.103 328.896 145.59 328.567 146.126 328.342C146.663 328.118 147.238 328.001 147.82 328Z",
    fill: "#F0F0F0"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M178.01 335.381H143.42V339.271H178.01V335.381Z",
    fill: "#E6E6E6"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M163.09 375.711H171.71C172.339 375.711 172.941 375.961 173.386 376.405C173.83 376.85 174.08 377.452 174.08 378.081V382.281H160.71V378.081C160.71 377.769 160.772 377.46 160.891 377.172C161.011 376.883 161.187 376.622 161.408 376.402C161.629 376.181 161.891 376.007 162.18 375.888C162.469 375.77 162.778 375.71 163.09 375.711Z",
    fill: "#E0E0E0"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M174.12 382.281H164.54C164.132 382.281 163.74 382.119 163.451 381.83C163.162 381.541 163 381.149 163 380.741C163.003 380.334 163.166 379.945 163.455 379.658C163.743 379.372 164.133 379.211 164.54 379.211H174.12C174.527 379.211 174.917 379.372 175.205 379.658C175.494 379.945 175.657 380.334 175.66 380.741C175.66 381.149 175.498 381.541 175.209 381.83C174.92 382.119 174.528 382.281 174.12 382.281Z",
    fill: "#E6E6E6"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M327.714 106.704C340.372 103.717 348.212 91.0328 345.225 78.3743C342.237 65.7158 329.553 57.8761 316.895 60.8638C304.236 63.8514 296.396 76.5352 299.384 89.1937C302.372 101.852 315.055 109.692 327.714 106.704Z",
    fill: "#E0E0E0"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M325.507 103.528C336.427 101.756 343.842 91.4672 342.069 80.5479C340.297 69.6285 330.008 62.2135 319.089 63.986C308.17 65.7585 300.754 76.0472 302.527 86.9665C304.299 97.8859 314.588 105.301 325.507 103.528Z",
    fill: "#F0F0F0"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M323.25 70.0293V84.0293L332.52 78.7793",
    fill: "#F0F0F0"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M323.25 85C323.071 84.9999 322.894 84.9516 322.74 84.86C322.591 84.7715 322.467 84.6457 322.381 84.4949C322.295 84.3441 322.25 84.1735 322.25 84V70C322.25 69.7348 322.355 69.4804 322.543 69.2929C322.73 69.1054 322.985 69 323.25 69C323.515 69 323.77 69.1054 323.957 69.2929C324.145 69.4804 324.25 69.7348 324.25 70V82.31L332.03 77.91C332.261 77.7805 332.534 77.7477 332.789 77.8189C333.043 77.8902 333.26 78.0596 333.39 78.29C333.52 78.5196 333.555 78.7915 333.485 79.0463C333.416 79.3011 333.249 79.5181 333.02 79.65L323.74 84.9C323.587 84.9709 323.419 85.0051 323.25 85Z",
    fill: "#E0E0E0"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M96.93 313.64C95.13 310.64 92.17 313.25 92.17 313.25C92.59 307.57 87.37 303.69 87.37 303.69C87.37 303.69 93.44 303.69 94.28 297.9C95.12 292.11 92.17 294.8 89.39 294.76C86.61 294.72 83.7 302.84 87.39 307.41C91.08 311.98 90.07 319.78 81.6 327.28C79.5746 329.176 78.0552 331.548 77.18 334.18C77.82 327.29 78.18 317.58 76.18 311.1C72.74 300.1 79.3 297.1 81.18 291.62C83.06 286.14 76.18 281.46 76.18 281.46C76.18 281.46 82.69 278.46 79.51 275.11C76.33 271.76 69.77 272.18 69.77 276.61C69.77 281.04 74.22 282.73 74.22 282.73C74.22 282.73 79.3 288.02 79.3 290.73C79.3 293.44 74.22 299.41 74.22 299.41C74.22 299.41 76.55 294.34 71.89 294.13C67.23 293.92 65.7501 300.05 67.6601 302.8C69.5701 305.55 72.74 303.23 72.74 303.23C72.9389 306.441 73.4242 309.627 74.19 312.75C74.67 314.34 74.45 320.55 74.05 327.01C73.1657 324.678 71.7519 322.583 69.92 320.89C61.45 313.39 60.47 305.59 64.14 301.02C67.81 296.45 64.9 288.33 62.14 288.37C59.38 288.41 56.39 285.71 57.24 291.5C58.09 297.29 64.1601 297.3 64.1601 297.3C64.1601 297.3 58.93 301.18 59.35 306.86C59.35 306.86 56.35 304.28 54.59 307.25C51.38 312.54 58.83 315.82 60.08 313.25C60.08 313.25 75.87 324.43 72.08 340.52L72.96 341.83C72.85 343.13 72.78 343.91 72.78 343.91L74.01 343.38L75.42 345.45C75.3707 347.789 75.4911 350.129 75.78 352.45L79.55 346.87C75.74 330.78 91.55 319.6 91.55 319.6C92.7001 322.22 100.14 318.93 96.93 313.64Z",
    fill: "#E0E0E0"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.93 313.64C95.13 310.64 92.17 313.25 92.17 313.25C92.59 307.57 87.37 303.69 87.37 303.69C87.37 303.69 93.44 303.69 94.28 297.9C95.12 292.11 92.17 294.8 89.39 294.76C86.61 294.72 83.7 302.84 87.39 307.41C91.08 311.98 90.07 319.78 81.6 327.28C79.5746 329.176 78.0552 331.548 77.18 334.18C77.82 327.29 78.18 317.58 76.18 311.1C72.74 300.1 79.3 297.1 81.18 291.62C83.06 286.14 76.18 281.46 76.18 281.46C76.18 281.46 82.69 278.46 79.51 275.11C76.33 271.76 69.77 272.18 69.77 276.61C69.77 281.04 74.22 282.73 74.22 282.73C74.22 282.73 79.3 288.02 79.3 290.73C79.3 293.44 74.22 299.41 74.22 299.41C74.22 299.41 76.55 294.34 71.89 294.13C67.23 293.92 65.7501 300.05 67.6601 302.8C69.5701 305.55 72.74 303.23 72.74 303.23C72.9389 306.441 73.4242 309.627 74.19 312.75C74.67 314.34 74.45 320.55 74.05 327.01C73.1657 324.678 71.7519 322.583 69.92 320.89C61.45 313.39 60.47 305.59 64.14 301.02C67.81 296.45 64.9 288.33 62.14 288.37C59.38 288.41 56.39 285.71 57.24 291.5C58.09 297.29 64.1601 297.3 64.1601 297.3C64.1601 297.3 58.93 301.18 59.35 306.86C59.35 306.86 56.35 304.28 54.59 307.25C51.38 312.54 58.83 315.82 60.08 313.25C60.08 313.25 75.87 324.43 72.08 340.52L72.96 341.83C72.85 343.13 72.78 343.91 72.78 343.91L74.01 343.38L75.42 345.45C75.3707 347.789 75.4911 350.129 75.78 352.45L79.55 346.87C75.74 330.78 91.55 319.6 91.55 319.6C92.7001 322.22 100.14 318.93 96.93 313.64Z",
    fill: "#E0E0E0"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M93.84 382.28H57.67L53.77 342.68H97.75L93.84 382.28Z",
    fill: "#E6E6E6"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M99.67 338.311H51.83V347.051H99.67V338.311Z",
    fill: "#F0F0F0"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M250 427.56C357.082 427.56 443.89 422.492 443.89 416.24C443.89 409.988 357.082 404.92 250 404.92C142.917 404.92 56.11 409.988 56.11 416.24C56.11 422.492 142.917 427.56 250 427.56Z",
    fill: "#F5F5F5"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M410.45 384.719C410.6 383.719 414.1 359.549 407.09 351.209C406.392 350.33 405.508 349.617 404.502 349.121C403.496 348.625 402.392 348.358 401.27 348.339C387.11 348.009 385.18 359.339 385.16 359.489L386.83 359.749C386.89 359.339 388.57 349.749 401.23 350.029C402.112 350.042 402.98 350.251 403.771 350.642C404.561 351.033 405.255 351.596 405.8 352.289C412.32 360.059 408.8 384.219 408.8 384.469L410.45 384.719Z",
    fill: "url(#paint0_linear_977_161)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M411.3 383.619L412.99 383.559C412.99 383.339 412.43 361.309 423.28 356.759C433.92 352.309 438.71 361.469 438.9 361.859L440.41 361.099C440.36 360.989 434.74 350.099 422.63 355.209C410.71 360.199 411.27 382.659 411.3 383.619Z",
    fill: "url(#paint1_linear_977_161)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M411.25 385.349C411.25 384.999 411.36 350.159 418.15 339.969C424.67 330.179 435.15 334.789 435.64 334.969L436.33 333.429C436.21 333.379 424.07 328.019 416.74 339.009C409.67 349.619 409.57 383.869 409.57 385.329L411.25 385.349Z",
    fill: "url(#paint2_linear_977_161)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M399.24 349.179C399.24 349.179 405.42 351.459 403.58 356.829C401.74 362.199 382.21 371.059 382.21 371.059C382.21 371.059 374.02 363.559 381.54 351.359C389.06 339.159 399.07 345.329 399.24 349.179Z",
    fill: "url(#paint3_linear_977_161)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M418.45 338.129C418.45 338.129 414.07 337.659 414.45 334.989C414.83 332.319 431.51 325.439 441.36 336.559C441.36 336.559 435.05 347.399 425.93 347.559C416.81 347.719 418.45 338.129 418.45 338.129Z",
    fill: "url(#paint4_linear_977_161)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M423 355.999C423 355.999 420 353.559 423.24 352.369C426.48 351.179 442.54 351.509 442.7 367.369C442.7 367.369 424.03 370.479 421.7 364.429C419.37 358.379 423 355.999 423 355.999Z",
    fill: "url(#paint5_linear_977_161)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M399.24 349.179C399.24 349.179 405.42 351.459 403.58 356.829C401.74 362.199 382.21 371.059 382.21 371.059C382.21 371.059 374.02 363.559 381.54 351.359C389.06 339.159 399.07 345.329 399.24 349.179Z",
    fill: "black"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.45 338.129C418.45 338.129 414.07 337.659 414.45 334.989C414.83 332.319 431.51 325.439 441.36 336.559C441.36 336.559 435.05 347.399 425.93 347.559C416.81 347.719 418.45 338.129 418.45 338.129Z",
    fill: "black"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M423 355.999C423 355.999 420 353.559 423.24 352.369C426.48 351.179 442.54 351.509 442.7 367.369C442.7 367.369 424.03 370.479 421.7 364.429C419.37 358.379 423 355.999 423 355.999Z",
    fill: "black"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M395.92 417.07H424.9L428.02 385.35H392.8L395.92 417.07Z",
    fill: "url(#paint6_linear_977_161)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M395.92 417.07H424.9L428.02 385.35H392.8L395.92 417.07Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M391.25 388.84H429.57V381.84H391.25V388.84Z",
    fill: "url(#paint7_linear_977_161)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.25 388.84H429.57V381.84H391.25V388.84Z",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M363.12 394.33L334.31 391.5V351H322.89V391.48L294 394.33C292.615 394.466 291.329 395.113 290.394 396.144C289.459 397.176 288.941 398.518 288.94 399.91V404.24H368.22V399.91C368.221 398.511 367.697 397.162 366.754 396.13C365.81 395.097 364.513 394.455 363.12 394.33Z",
    fill: "#263238"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.12 394.33L334.31 391.5V351H322.89V391.48L294 394.33C292.615 394.466 291.329 395.113 290.394 396.144C289.459 397.176 288.941 398.518 288.94 399.91V404.24H368.22V399.91C368.221 398.511 367.697 397.162 366.754 396.13C365.81 395.097 364.513 394.455 363.12 394.33Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M291.95 417.081C296.076 417.081 299.42 413.736 299.42 409.611C299.42 405.485 296.076 402.141 291.95 402.141C287.824 402.141 284.48 405.485 284.48 409.611C284.48 413.736 287.824 417.081 291.95 417.081Z",
    fill: "#263238"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M365.14 417.081C369.265 417.081 372.61 413.736 372.61 409.611C372.61 405.485 369.265 402.141 365.14 402.141C361.014 402.141 357.67 405.485 357.67 409.611C357.67 413.736 361.014 417.081 365.14 417.081Z",
    fill: "#263238"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M320.93 323.641H336.28V355.571C336.28 356.666 335.845 357.716 335.07 358.491C334.296 359.265 333.245 359.701 332.15 359.701H325.06C323.965 359.701 322.914 359.265 322.14 358.491C321.365 357.716 320.93 356.666 320.93 355.571V323.641Z",
    fill: "#263238"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M320.93 323.641H336.28V355.571C336.28 356.666 335.845 357.716 335.07 358.491C334.296 359.265 333.245 359.701 332.15 359.701H325.06C323.965 359.701 322.914 359.265 322.14 358.491C321.365 357.716 320.93 356.666 320.93 355.571V323.641Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M355.9 260.35C355.9 260.35 358.08 314.35 343.04 323.64H360.21C360.21 323.64 373.51 305.25 369.75 260.35H355.9Z",
    fill: "#263238"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M355.9 260.35C355.9 260.35 358.08 314.35 343.04 323.64H360.21C360.21 323.64 373.51 305.25 369.75 260.35H355.9Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M366.05 327.781H289.13V321.091C289.13 319.765 289.657 318.493 290.594 317.556C291.532 316.618 292.804 316.091 294.13 316.091H361.05C362.376 316.091 363.648 316.618 364.585 317.556C365.523 318.493 366.05 319.765 366.05 321.091V327.781Z",
    fill: "#263238"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M287.93 327.781H367.24C368.35 327.781 369.25 326.881 369.25 325.771V323.951C369.25 322.841 368.35 321.941 367.24 321.941H287.93C286.82 321.941 285.92 322.841 285.92 323.951V325.771C285.92 326.881 286.82 327.781 287.93 327.781Z",
    fill: "#263238"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M287.93 327.781H367.24C368.35 327.781 369.25 326.881 369.25 325.771V323.951C369.25 322.841 368.35 321.941 367.24 321.941H287.93C286.82 321.941 285.92 322.841 285.92 323.951V325.771C285.92 326.881 286.82 327.781 287.93 327.781Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M373.96 231.4H346.46C338.408 231.4 331.88 237.928 331.88 245.98V256.74C331.88 264.793 338.408 271.32 346.46 271.32H373.96C382.012 271.32 388.54 264.793 388.54 256.74V245.98C388.54 237.928 382.012 231.4 373.96 231.4Z",
    fill: "#263238"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M263.05 187.28L257.56 172.81C257.56 172.81 259.92 170.63 258.3 168.42C256.68 166.21 246.56 160 244.72 161.09C242.88 162.18 238.77 166.3 240.99 168.59C243.21 170.88 252.99 174.69 252.99 174.69L257.85 193.69L263.05 187.28Z",
    fill: "#E4897B"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M301.38 214.79C301.38 214.79 276.38 209.66 273.71 208.43C271.04 207.2 261 177.77 261 177.77L253.29 181.37C253.29 181.37 259.49 210.91 265.83 217.93C272.17 224.95 299.23 230.93 299.23 230.93L301.38 214.79Z",
    fill: "url(#paint8_linear_977_161)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.17 230.9L298.71 230.79C297.35 230.48 293.08 229.48 288.01 227.99C279.78 225.6 269.4 221.99 265.78 217.94C259.45 210.94 253.24 181.37 253.24 181.37L260.94 177.77C260.94 177.77 270.99 207.21 273.71 208.43C276.43 209.65 301.38 214.79 301.38 214.79L299.17 230.9Z",
    fill: "black"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M261.07 177.189L262.66 180.259L252.76 183.669L253.14 179.919L261.07 177.189Z",
    fill: "url(#paint9_linear_977_161)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.36 230.49C297.98 230.29 293.65 229.62 288.47 228.49C291.42 223.39 300.06 220.77 300.06 220.77L299.36 230.49Z",
    fill: "black"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M336.58 194.41C336.58 194.41 338.05 208.24 332.93 211.64C327.81 215.04 302.6 211.06 299.74 205.49C296.88 199.92 307.64 184.82 307.64 184.82L336.58 194.41Z",
    fill: "#263238"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M234.59 376.389L241.17 377.979L244.5 368.899L247.52 360.639L240.03 357.449L237.15 367.469L234.59 376.389Z",
    fill: "#E4897B"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.15 367.469L244.5 368.899L247.52 360.639L240.03 357.449L237.15 367.469Z",
    fill: "black"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M237.81 362.68L246.93 366.07C246.93 366.07 271.26 305.24 276.26 305.07C281.26 304.9 332.17 328.26 344.93 315.28C357.69 302.3 339.24 271 339.24 271C339.24 271 308.55 266.62 306.24 273.55C305.672 275.593 305.237 277.671 304.94 279.77C304.59 281.89 304.35 283.67 304.35 283.67C303.4 283.43 272.59 275.48 260.45 283.67C248.1 292 237.81 362.68 237.81 362.68Z",
    fill: "url(#paint10_linear_977_161)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M237.81 362.68L246.93 366.07C246.93 366.07 271.26 305.24 276.26 305.07C281.26 304.9 332.17 328.26 344.93 315.28C357.69 302.3 339.24 271 339.24 271C339.24 271 308.55 266.62 306.24 273.55C305.672 275.593 305.237 277.671 304.94 279.77C304.59 281.89 304.35 283.67 304.35 283.67C303.4 283.43 272.59 275.48 260.45 283.67C248.1 292 237.81 362.68 237.81 362.68Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M290.27 402.341L296.82 400.671L295.56 391.261L294.39 382.641L286.29 383.371L288.39 393.421L290.27 402.341Z",
    fill: "#E4897B"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.44 393.62L295.6 391.44L294.41 382.73L286.3 383.42L288.44 393.62Z",
    fill: "black"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M250.7 362.69L237.41 358.18L236.84 363.62L246.92 367.18L250.7 362.69Z",
    fill: "url(#paint11_linear_977_161)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M322.89 318.36C322.89 318.36 320.81 318.41 288.62 316.91C288.62 316.91 293.43 357.15 296.06 387.28L286.43 388.92C286.43 388.92 263.43 324.41 263.68 314.16C263.93 303.91 275.68 300.91 275.68 300.91C275.68 300.91 298.61 314.16 322.89 318.36Z",
    fill: "url(#paint12_linear_977_161)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M322.89 318.36C322.89 318.36 320.81 318.41 288.62 316.91C288.62 316.91 293.43 357.15 296.06 387.28L286.43 388.92C286.43 388.92 263.43 324.41 263.68 314.16C263.93 303.91 275.68 300.91 275.68 300.91C275.68 300.91 298.61 314.16 322.89 318.36Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M322.89 318.36C322.89 318.36 320.81 318.41 288.62 316.91C288.62 316.91 293.43 357.15 296.06 387.28L286.43 388.92C286.43 388.92 263.43 324.41 263.68 314.16C263.93 303.91 275.68 300.91 275.68 300.91C275.68 300.91 298.61 314.16 322.89 318.36Z",
    fill: "black"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M297.46 384.359L284.23 385.869L286.79 391.049L297.5 389.679L297.46 384.359Z",
    fill: "url(#paint13_linear_977_161)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M304.35 283.67L322.3 287.41C322.3 287.41 312.38 281.93 304.94 279.77C304.59 281.89 304.35 283.67 304.35 283.67Z",
    fill: "black"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 266.23L339.24 271L306.24 273.55L305.37 267.9L338.5 266.23Z",
    fill: "#263238"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M338.5 266.23L339.24 271L306.24 273.55L305.37 267.9L338.5 266.23Z",
    fill: "black"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M328.092 274.222L329.723 274.055L328.869 265.748L327.238 265.916L328.092 274.222Z",
    fill: "url(#paint14_linear_977_161)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M313.431 273.392L320.656 272.928L320.304 267.449L313.079 267.914L313.431 273.392Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M307.845 275.095L309.476 274.928L308.622 266.622L306.991 266.789L307.845 275.095Z",
    fill: "url(#paint15_linear_977_161)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M328.092 274.222L329.723 274.055L328.869 265.748L327.238 265.916L328.092 274.222Z",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M307.845 275.095L309.476 274.928L308.622 266.622L306.991 266.789L307.845 275.095Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M300.78 214.34C306.961 216.047 313.376 216.753 319.78 216.43C330.38 215.89 343 221 343 221L338.46 266.2L305.32 267.87C305.32 267.87 294.23 230.16 300.78 214.34Z",
    fill: "url(#paint16_linear_977_161)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M306.11 188.81C306.11 188.81 307.97 166.87 326.31 174.81C349.31 184.81 331.03 211.55 319.78 206.07C308.53 200.59 306.11 188.81 306.11 188.81Z",
    fill: "#263238"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.25 217.66L311.78 230.06L315.89 224.23C315.89 224.23 314.42 237.94 315.28 245.41C315.28 245.41 316.07 232.02 317.93 224.23L322.3 230.06L328.57 217.74C328.57 217.74 318.42 214.09 311.25 217.66Z",
    fill: "black"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M316.93 220L326.42 217.32C320.57 213.32 323.52 204.32 323.52 204.32L314.12 207.62C314.552 208.927 314.887 210.264 315.12 211.62C316.12 217.48 313.46 217.95 313.46 217.95L316.93 220Z",
    fill: "#E4897B"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.12 207.57C314.552 208.877 314.887 210.214 315.12 211.57C319.62 209.76 323.51 204.25 323.51 204.25L314.12 207.57Z",
    fill: "black"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M320.26 179.45C311.93 177.61 308.26 181.45 305.76 189.91C302.63 200.46 303.32 208.6 314.23 208.62C329.05 208.64 334.08 182.51 320.26 179.45Z",
    fill: "#E4897B"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M311.24 190.641C310.302 191.736 309.235 192.714 308.06 193.551C308.228 193.951 308.504 194.297 308.857 194.549C309.21 194.802 309.627 194.951 310.06 194.981L311.24 190.641Z",
    fill: "#DE5753"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M316.49 191.08C316.32 191.76 316.55 192.41 317.01 192.52C317.47 192.63 317.96 192.17 318.13 191.52C318.3 190.87 318.07 190.2 317.61 190.08C317.15 189.96 316.66 190.4 316.49 191.08Z",
    fill: "#263238"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M317.79 190.129L316.46 189.189C316.46 189.189 316.89 190.619 317.79 190.129Z",
    fill: "#263238"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M308.07 188.86C307.9 189.54 308.13 190.19 308.59 190.3C309.05 190.41 309.59 189.95 309.71 189.3C309.83 188.65 309.65 187.98 309.19 187.86C308.73 187.74 308.24 188.18 308.07 188.86Z",
    fill: "#263238"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M309.37 187.91L308 187C308 187 308.47 188.39 309.37 187.91Z",
    fill: "#263238"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M321.18 187.77C321.113 187.771 321.047 187.754 320.989 187.72C320.931 187.687 320.883 187.638 320.85 187.58C320.521 187.065 320.08 186.631 319.561 186.309C319.042 185.988 318.457 185.786 317.85 185.72C317.755 185.707 317.667 185.659 317.606 185.585C317.545 185.51 317.514 185.416 317.52 185.32C317.53 185.223 317.578 185.135 317.653 185.073C317.727 185.011 317.823 184.981 317.92 184.99C318.657 185.061 319.368 185.302 319.996 185.694C320.624 186.086 321.152 186.619 321.54 187.25C321.562 187.292 321.576 187.339 321.58 187.387C321.584 187.435 321.578 187.483 321.563 187.528C321.548 187.574 321.524 187.616 321.493 187.653C321.462 187.689 321.423 187.718 321.38 187.74C321.316 187.765 321.248 187.775 321.18 187.77Z",
    fill: "#263238"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M311.87 184C311.802 183.998 311.736 183.978 311.68 183.94C311.188 183.704 310.65 183.581 310.105 183.581C309.56 183.581 309.022 183.704 308.53 183.94C308.487 183.957 308.44 183.966 308.394 183.966C308.347 183.965 308.301 183.955 308.258 183.937C308.215 183.918 308.176 183.891 308.144 183.857C308.112 183.823 308.087 183.783 308.07 183.74C308.052 183.696 308.043 183.649 308.043 183.601C308.044 183.554 308.054 183.507 308.072 183.463C308.091 183.419 308.118 183.38 308.152 183.347C308.186 183.313 308.226 183.287 308.27 183.27C308.867 182.992 309.521 182.854 310.179 182.868C310.838 182.882 311.485 183.047 312.07 183.35C312.11 183.375 312.145 183.408 312.172 183.447C312.2 183.486 312.219 183.53 312.229 183.577C312.24 183.623 312.24 183.671 312.232 183.718C312.224 183.765 312.206 183.81 312.18 183.85C312.144 183.898 312.098 183.937 312.043 183.963C311.989 183.989 311.93 184.002 311.87 184Z",
    fill: "#263238"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M326.25 195.489C326.25 195.489 323.87 187.789 325.63 182.639C325.63 182.639 310.63 172.249 306.11 188.809C306.11 188.809 307.78 173.589 322.17 176.429C336.56 179.269 331.85 200.179 323.08 204.779C323.08 204.779 327.71 200.299 326.25 195.489Z",
    fill: "#263238"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 197C324.793 196.054 325.449 195.262 326.324 194.799C327.2 194.336 328.223 194.239 329.17 194.53C331.69 195.38 331.74 200.95 325.05 200.8C324.08 200.73 323.76 199.72 324.5 197Z",
    fill: "#E4897B"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M308.55 198.141C308.773 199.162 308.92 200.198 308.99 201.241H309.53C312.02 201.451 313.24 200.721 313.84 199.861C314.127 199.433 314.305 198.942 314.36 198.431C314.402 198.142 314.402 197.849 314.36 197.561C312.755 198.113 311.05 198.315 309.36 198.151C308.88 198.181 308.55 198.141 308.55 198.141Z",
    fill: "#263238"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M309.4 198.199L309.55 199.109C311.89 199.299 313.55 199.109 314.36 198.479C314.402 198.191 314.402 197.898 314.36 197.609C312.767 198.157 311.077 198.358 309.4 198.199Z",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M309.53 201.29C312.02 201.5 313.24 200.77 313.84 199.91C312.896 199.848 311.948 199.953 311.04 200.22C310.437 200.408 309.908 200.783 309.53 201.29Z",
    fill: "#DE5753"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M320.29 180.12C320.29 180.12 320.61 194.55 329.29 196.29C337.97 198.03 328.49 177.73 328.49 177.73C328.49 177.73 315.59 169.31 306.99 175.25C298.39 181.19 306.13 188.81 306.13 188.81C306.13 188.81 307.92 178.09 320.29 180.12Z",
    fill: "#263238"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M323.6 193.329C323.541 193.329 323.485 193.308 323.44 193.269C317.28 188.429 320.32 179.169 320.35 179.079C320.373 179.017 320.419 178.965 320.478 178.936C320.538 178.906 320.606 178.9 320.67 178.919C320.732 178.942 320.783 178.988 320.811 179.048C320.839 179.108 320.843 179.177 320.82 179.239C320.82 179.329 317.87 188.239 323.75 192.879C323.774 192.902 323.793 192.929 323.806 192.959C323.819 192.989 323.826 193.022 323.826 193.054C323.826 193.087 323.819 193.12 323.806 193.15C323.793 193.18 323.774 193.207 323.75 193.229C323.733 193.256 323.712 193.278 323.686 193.296C323.66 193.313 323.631 193.324 323.6 193.329Z",
    fill: "#263238"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M331.8 199.25C330.7 202.19 327.87 203.84 325.48 202.95C323.09 202.06 322.05 198.95 323.15 196.01C324.25 193.07 327.08 191.42 329.47 192.32C331.86 193.22 332.9 196.32 331.8 199.25Z",
    fill: "url(#paint17_linear_977_161)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M331.8 199.25C330.7 202.19 327.87 203.84 325.48 202.95C323.09 202.06 322.05 198.95 323.15 196.01C324.25 193.07 327.08 191.42 329.47 192.32C331.86 193.22 332.9 196.32 331.8 199.25Z",
    fill: "black"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M329 194.44C329 194.44 332.59 178.37 324.54 174.16C325.457 174.28 326.365 174.457 327.26 174.69C328.26 174.99 334.73 181.51 331.48 195.95L329 194.44Z",
    fill: "url(#paint18_linear_977_161)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M329 194.44C329 194.44 332.59 178.37 324.54 174.16C325.457 174.28 326.365 174.457 327.26 174.69C328.26 174.99 334.73 181.51 331.48 195.95L329 194.44Z",
    fill: "black"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M314 203.639L313.4 203.549L313.56 202.549C317.976 203.229 322.489 202.272 326.25 199.859L326.84 200.659C323.058 203.166 318.499 204.224 314 203.639Z",
    fill: "url(#paint19_linear_977_161)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314 203.639L313.4 203.549L313.56 202.549C317.976 203.229 322.489 202.272 326.25 199.859L326.84 200.659C323.058 203.166 318.499 204.224 314 203.639Z",
    fill: "black"
  }))), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M331.46 198.85C330.74 200.79 328.86 201.85 327.29 201.29C325.72 200.73 325.02 198.65 325.75 196.71C326.48 194.77 328.35 193.71 329.92 194.27C331.49 194.83 332.19 196.91 331.46 198.85Z",
    fill: "url(#paint20_linear_977_161)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M313.06 204.001L312.25 203.891C312.109 203.872 311.972 203.826 311.849 203.755C311.725 203.683 311.617 203.588 311.531 203.475C311.444 203.361 311.381 203.232 311.345 203.094C311.309 202.956 311.3 202.812 311.32 202.671C311.337 202.529 311.383 202.391 311.454 202.267C311.524 202.142 311.619 202.033 311.733 201.945C311.847 201.858 311.976 201.794 312.115 201.757C312.254 201.72 312.398 201.711 312.54 201.731L313.34 201.841C313.625 201.881 313.883 202.031 314.059 202.259C314.235 202.487 314.314 202.775 314.28 203.061C314.24 203.346 314.09 203.604 313.862 203.78C313.634 203.956 313.346 204.035 313.06 204.001Z",
    fill: "url(#paint21_linear_977_161)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M313.06 204.001L312.25 203.891C312.109 203.872 311.972 203.826 311.849 203.755C311.725 203.683 311.617 203.588 311.531 203.475C311.444 203.361 311.381 203.232 311.345 203.094C311.309 202.956 311.3 202.812 311.32 202.671C311.337 202.529 311.383 202.391 311.454 202.267C311.524 202.142 311.619 202.033 311.733 201.945C311.847 201.858 311.976 201.794 312.115 201.757C312.254 201.72 312.398 201.711 312.54 201.731L313.34 201.841C313.625 201.881 313.883 202.031 314.059 202.259C314.235 202.487 314.314 202.775 314.28 203.061C314.24 203.346 314.09 203.604 313.862 203.78C313.634 203.956 313.346 204.035 313.06 204.001Z",
    fill: "black"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M323.87 213.85L317.93 219.68L320.31 226.84L328.57 217.74L323.87 213.85Z",
    fill: "url(#paint22_linear_977_161)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M315.28 215.07L316.24 219.56L313.17 225.91L311.25 217.66L315.28 215.07Z",
    fill: "url(#paint23_linear_977_161)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M322.6 218.911L326.05 206.281C326.05 206.281 324.38 203.141 324.74 202.481C325.1 201.821 326.9 193.341 328.18 192.421C329.46 191.501 334.73 193.071 335.26 193.931C335.79 194.791 330.21 206.281 330.21 206.281L328.21 219.971L322.6 218.911Z",
    fill: "#E4897B"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M343 220.999C352.5 230.719 333.47 252.739 322.56 251.799C311.65 250.859 322.84 210.939 322.84 210.939L329.84 212.089C329.84 212.089 327.39 229.369 328.16 230.719C328.93 232.069 339.85 217.769 343 220.999Z",
    fill: "url(#paint24_linear_977_161)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M343 220.999C352.5 230.719 333.47 252.739 322.56 251.799C311.65 250.859 322.84 210.939 322.84 210.939L329.84 212.089C329.84 212.089 327.39 229.369 328.16 230.719C328.93 232.069 339.85 217.769 343 220.999Z",
    fill: "black"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 209.689L321.27 212.989L331 213.849V210.969L322.3 209.689Z",
    fill: "url(#paint25_linear_977_161)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M307.55 235.801H303.61C303.174 235.801 302.82 236.154 302.82 236.591V244.031C302.82 244.467 303.174 244.821 303.61 244.821H307.55C307.986 244.821 308.34 244.467 308.34 244.031V236.591C308.34 236.154 307.986 235.801 307.55 235.801Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307.63 236.4H303.15V242.53H307.63V236.4Z",
    fill: "black"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M305.99 233.631H305V237.241H305.99V233.631Z",
    fill: "#263238"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M223.71 389.169C224.707 388.705 225.782 388.431 226.88 388.359C226.88 388.359 230.68 386.129 234.44 377.439H238.67C239.387 377.445 240.085 377.671 240.669 378.088C241.253 378.505 241.693 379.092 241.93 379.769C242.001 379.955 242.041 380.151 242.05 380.349C242 381.372 241.89 382.39 241.72 383.399C241.101 386.78 240.276 390.12 239.25 393.399L238.53 393.219L239.83 386.899C240.27 384.759 238.01 386.829 236.97 388.989C235.93 391.149 234.32 393.339 229.64 392.269C224.19 390.929 222 390.149 223.71 389.169Z",
    fill: "url(#paint26_linear_977_161)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M235.21 375.17C235.21 375.17 229.92 386.23 226.88 388.36C226.88 388.36 230.96 390.79 235.21 385.36C240.7 378.36 242.05 380.31 242.05 380.31C241.935 379.102 241.711 377.907 241.38 376.74C240.56 374.5 235.21 375.17 235.21 375.17Z",
    fill: "#E4897B"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M281.93 415.519C282.794 414.838 283.773 414.317 284.82 413.979C284.82 413.979 287.98 410.909 289.57 401.579L293.68 400.579C294.378 400.419 295.108 400.476 295.771 400.745C296.435 401.013 297 401.479 297.39 402.079C297.502 402.246 297.59 402.428 297.65 402.619C297.85 403.61 297.987 404.612 298.06 405.619C298.252 409.037 298.235 412.463 298.01 415.879H297.27L297.04 409.439C296.95 407.249 295.26 409.799 294.75 412.149C294.24 414.499 293.21 416.989 288.41 417.059C282.82 417.119 280.5 416.879 281.93 415.519Z",
    fill: "url(#paint27_linear_977_161)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M289.78 399.19C289.78 399.19 287.27 411.19 284.78 413.98C284.78 413.98 289.32 415.38 292.16 409.11C295.84 401.01 297.61 402.59 297.61 402.59C297.215 401.444 296.716 400.336 296.12 399.28C294.82 397.28 289.78 399.19 289.78 399.19Z",
    fill: "#E4897B"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M382.76 157.15H347.85C345.05 157.15 342.78 159.42 342.78 162.22V177.15C342.78 179.95 345.05 182.22 347.85 182.22H382.76C385.56 182.22 387.83 179.95 387.83 177.15V162.22C387.83 159.42 385.56 157.15 382.76 157.15Z",
    fill: "url(#paint28_linear_977_161)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M354.85 179.361L344.33 193.661L361.3 180.321L354.85 179.361Z",
    fill: "url(#paint29_linear_977_161)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M355.24 169.681C355.242 169.975 355.157 170.262 354.995 170.507C354.833 170.752 354.602 170.943 354.331 171.056C354.06 171.17 353.762 171.2 353.474 171.143C353.186 171.086 352.921 170.945 352.714 170.737C352.506 170.53 352.365 170.265 352.308 169.977C352.251 169.689 352.281 169.391 352.395 169.12C352.508 168.849 352.699 168.618 352.944 168.456C353.189 168.294 353.476 168.209 353.77 168.211C354.16 168.211 354.534 168.366 354.809 168.642C355.085 168.917 355.24 169.291 355.24 169.681Z",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M362.93 169.681C362.932 169.975 362.847 170.262 362.685 170.507C362.523 170.752 362.292 170.943 362.021 171.056C361.75 171.17 361.452 171.2 361.164 171.143C360.876 171.086 360.611 170.945 360.404 170.737C360.196 170.53 360.055 170.265 359.998 169.977C359.941 169.689 359.971 169.391 360.085 169.12C360.198 168.849 360.389 168.618 360.634 168.456C360.879 168.294 361.166 168.209 361.46 168.211C361.85 168.211 362.224 168.366 362.5 168.642C362.775 168.917 362.93 169.291 362.93 169.681Z",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M370.62 169.681C370.622 169.975 370.537 170.262 370.375 170.507C370.213 170.752 369.982 170.943 369.711 171.056C369.44 171.17 369.142 171.2 368.854 171.143C368.566 171.086 368.301 170.945 368.094 170.737C367.886 170.53 367.745 170.265 367.688 169.977C367.631 169.689 367.661 169.391 367.775 169.12C367.888 168.849 368.079 168.618 368.324 168.456C368.569 168.294 368.856 168.209 369.15 168.211C369.54 168.211 369.914 168.366 370.189 168.642C370.465 168.917 370.62 169.291 370.62 169.681Z",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M378.31 169.681C378.312 169.975 378.227 170.262 378.065 170.507C377.903 170.752 377.672 170.943 377.401 171.056C377.13 171.17 376.832 171.2 376.544 171.143C376.256 171.086 375.991 170.945 375.784 170.737C375.576 170.53 375.435 170.265 375.378 169.977C375.321 169.689 375.351 169.391 375.465 169.12C375.578 168.849 375.769 168.618 376.014 168.456C376.259 168.294 376.547 168.209 376.84 168.211C377.23 168.211 377.604 168.366 377.88 168.642C378.155 168.917 378.31 169.291 378.31 169.681Z",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M251.674 145.327L226.767 131.91C226.096 131.549 225.259 131.8 224.898 132.471L216.949 147.226C216.588 147.897 216.839 148.734 217.51 149.096L242.416 162.512C243.087 162.873 243.924 162.622 244.286 161.951L252.234 147.196C252.595 146.525 252.345 145.688 251.674 145.327Z",
    fill: "url(#paint30_linear_977_161)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M251.674 145.327L226.767 131.91C226.096 131.549 225.259 131.8 224.898 132.471L216.949 147.226C216.588 147.897 216.839 148.734 217.51 149.096L242.416 162.512C243.087 162.873 243.924 162.622 244.286 161.951L252.234 147.196C252.595 146.525 252.345 145.688 251.674 145.327Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.25 133.689L232 148.239C232.298 148.794 232.753 149.247 233.308 149.543C233.864 149.838 234.494 149.962 235.12 149.899L251.33 148.299L234.83 150.729C234.109 150.836 233.373 150.707 232.731 150.361C232.09 150.015 231.577 149.471 231.27 148.809L224.25 133.689Z",
    fill: "black"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M205.34 130.999C205.61 125.439 209.73 114.229 214.74 110.799C219.75 107.369 216.45 112.119 216.45 112.119C216.45 112.119 221.2 107.499 223.7 107.639C226.2 107.779 223.7 110.639 223.7 110.639C223.7 110.639 228.85 107.469 231.22 107.639C233.59 107.809 231.22 110.549 231.22 110.549C231.22 110.549 235.44 107.549 237.15 108.959C238.86 110.369 215.26 125.959 212.63 132.299C210 138.639 205.07 136.609 205.34 130.999Z",
    fill: "url(#paint31_linear_977_161)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M205.34 130.999C205.61 125.439 209.73 114.229 214.74 110.799C219.75 107.369 216.45 112.119 216.45 112.119C216.45 112.119 221.2 107.499 223.7 107.639C226.2 107.779 223.7 110.639 223.7 110.639C223.7 110.639 228.85 107.469 231.22 107.639C233.59 107.809 231.22 110.549 231.22 110.549C231.22 110.549 235.44 107.549 237.15 108.959C238.86 110.369 215.26 125.959 212.63 132.299C210 138.639 205.07 136.609 205.34 130.999Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M225.62 130.16L228.77 132.16C228.82 132.191 228.858 132.238 228.878 132.293C228.897 132.348 228.898 132.408 228.88 132.463C228.861 132.519 228.824 132.567 228.776 132.599C228.727 132.631 228.668 132.645 228.61 132.64L225.3 132.38L225.58 134.92C225.588 134.98 225.577 135.041 225.547 135.094C225.518 135.147 225.472 135.189 225.417 135.213C225.362 135.238 225.3 135.244 225.241 135.231C225.182 135.218 225.129 135.186 225.09 135.14L223.18 133L225.62 130.16Z",
    fill: "url(#paint32_linear_977_161)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.62 130.16L228.77 132.16C228.82 132.191 228.858 132.238 228.878 132.293C228.897 132.348 228.898 132.408 228.88 132.463C228.861 132.519 228.824 132.567 228.776 132.599C228.727 132.631 228.668 132.645 228.61 132.64L225.3 132.38L225.58 134.92C225.588 134.98 225.577 135.041 225.547 135.094C225.518 135.147 225.472 135.189 225.417 135.213C225.362 135.238 225.3 135.244 225.241 135.231C225.182 135.218 225.129 135.186 225.09 135.14L223.18 133L225.62 130.16Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M181.37 117.639C181.37 117.639 185.73 114.639 192.32 116.579C192.32 116.579 194.21 125.289 199.4 128.189C202.25 129.779 209.22 129.639 214.74 127.859C221.29 125.739 224.49 125.739 225.68 128.189C226.87 130.639 225.55 133.189 220.54 134.379C215.53 135.569 211.54 144.269 202.47 144.379C193.4 144.489 188.58 135.379 190.87 127.379C188.702 123.289 185.404 119.908 181.37 117.639Z",
    fill: "url(#paint33_linear_977_161)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.37 117.639C181.37 117.639 185.73 114.639 192.32 116.579C192.32 116.579 194.21 125.289 199.4 128.189C202.25 129.779 209.22 129.639 214.74 127.859C221.29 125.739 224.49 125.739 225.68 128.189C226.87 130.639 225.55 133.189 220.54 134.379C215.53 135.569 211.54 144.269 202.47 144.379C193.4 144.489 188.58 135.379 190.87 127.379C188.702 123.289 185.404 119.908 181.37 117.639Z",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M223.18 129.839C223.18 129.928 223.154 130.015 223.104 130.089C223.055 130.163 222.984 130.22 222.902 130.254C222.82 130.288 222.73 130.297 222.642 130.28C222.555 130.263 222.475 130.22 222.412 130.157C222.349 130.094 222.306 130.014 222.289 129.926C222.271 129.839 222.28 129.749 222.314 129.666C222.348 129.584 222.406 129.514 222.48 129.465C222.554 129.415 222.641 129.389 222.73 129.389C222.849 129.389 222.964 129.436 223.048 129.52C223.133 129.605 223.18 129.719 223.18 129.839Z",
    fill: "#263238"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M200.36 137.159C194.99 138.619 183.05 138.159 178.25 134.459C173.45 130.759 178.97 132.459 178.97 132.459C178.97 132.459 173.12 129.369 172.47 126.949C171.82 124.529 175.35 126.009 175.35 126.009C175.35 126.009 170.75 122.099 170.15 119.799C169.55 117.499 172.91 118.899 172.91 118.899C172.91 118.899 168.72 115.819 169.57 113.749C170.42 111.679 192.51 129.319 199.34 129.869C206.17 130.419 205.8 135.679 200.36 137.159Z",
    fill: "url(#paint34_linear_977_161)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M200.36 137.159C194.99 138.619 183.05 138.159 178.25 134.459C173.45 130.759 178.97 132.459 178.97 132.459C178.97 132.459 173.12 129.369 172.47 126.949C171.82 124.529 175.35 126.009 175.35 126.009C175.35 126.009 170.75 122.099 170.15 119.799C169.55 117.499 172.91 118.899 172.91 118.899C172.91 118.899 168.72 115.819 169.57 113.749C170.42 111.679 192.51 129.319 199.34 129.869C206.17 130.419 205.8 135.679 200.36 137.159Z",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M165.16 112.83C165.121 112.839 165.079 112.839 165.04 112.83C164.11 112.5 163.16 112.19 162.2 111.9C162.105 111.87 162.026 111.804 161.979 111.716C161.932 111.628 161.922 111.525 161.95 111.43C161.98 111.335 162.046 111.255 162.134 111.209C162.222 111.162 162.325 111.151 162.42 111.18C163.42 111.47 164.35 111.79 165.29 112.18C165.374 112.208 165.445 112.266 165.489 112.342C165.534 112.419 165.55 112.508 165.535 112.596C165.519 112.683 165.472 112.761 165.404 112.817C165.335 112.873 165.249 112.902 165.16 112.9V112.83Z",
    fill: "url(#paint35_linear_977_161)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M104.72 194C104.621 194 104.526 193.961 104.455 193.892C104.384 193.823 104.343 193.729 104.34 193.63C104.34 193.531 104.379 193.435 104.448 193.364C104.517 193.293 104.611 193.252 104.71 193.25C106.699 193.221 108.683 193.027 110.64 192.67C110.738 192.652 110.839 192.674 110.921 192.73C111.004 192.786 111.061 192.872 111.08 192.97C111.09 193.018 111.09 193.069 111.081 193.117C111.071 193.166 111.051 193.212 111.023 193.253C110.995 193.294 110.959 193.329 110.918 193.356C110.876 193.383 110.829 193.401 110.78 193.41C108.78 193.776 106.753 193.973 104.72 194ZM98.72 193.68C96.7021 193.464 94.6986 193.13 92.72 192.68C92.6221 192.658 92.5366 192.599 92.4823 192.514C92.428 192.43 92.4092 192.328 92.43 192.23C92.4538 192.134 92.5141 192.051 92.5981 191.998C92.6822 191.946 92.7833 191.929 92.88 191.95C94.8273 192.388 96.7968 192.722 98.78 192.95C98.8689 192.964 98.9498 193.01 99.0082 193.079C99.0665 193.147 99.0985 193.235 99.0985 193.325C99.0985 193.415 99.0665 193.502 99.0082 193.571C98.9498 193.639 98.8689 193.685 98.78 193.7L98.72 193.68ZM116.49 191.68C116.418 191.68 116.348 191.659 116.287 191.62C116.227 191.581 116.179 191.525 116.15 191.46C116.128 191.415 116.116 191.366 116.114 191.316C116.112 191.266 116.12 191.216 116.138 191.169C116.156 191.122 116.183 191.08 116.218 191.044C116.252 191.008 116.294 190.979 116.34 190.96C118.156 190.177 119.842 189.121 121.34 187.83C121.417 187.771 121.512 187.744 121.608 187.754C121.704 187.763 121.793 187.809 121.856 187.881C121.92 187.954 121.953 188.047 121.95 188.144C121.947 188.24 121.908 188.331 121.84 188.4C120.282 189.736 118.533 190.832 116.65 191.65C116.595 191.68 116.533 191.697 116.47 191.7L116.49 191.68ZM87 191C86.9606 191.009 86.9194 191.009 86.88 191C84.98 190.37 83.07 189.63 81.22 188.82C81.138 188.773 81.0764 188.697 81.0472 188.607C81.0179 188.518 81.0232 188.42 81.0619 188.334C81.1006 188.248 81.17 188.179 81.2565 188.141C81.343 188.104 81.4405 188.099 81.53 188.13C83.35 188.93 85.23 189.66 87.12 190.29C87.2136 190.324 87.2901 190.393 87.3331 190.483C87.3761 190.572 87.3821 190.675 87.35 190.77C87.3217 190.839 87.2731 190.898 87.2107 190.939C87.1482 190.98 87.0747 191.001 87 191ZM76 186.14C75.9413 186.157 75.8787 186.157 75.82 186.14C74.03 185.14 72.29 184.06 70.67 182.93C70.6299 182.901 70.5958 182.866 70.5696 182.824C70.5434 182.783 70.5256 182.737 70.5173 182.688C70.5089 182.64 70.5102 182.591 70.5209 182.543C70.5317 182.495 70.5518 182.45 70.58 182.41C70.6082 182.37 70.6441 182.336 70.6855 182.309C70.7269 182.283 70.7731 182.265 70.8213 182.257C70.8696 182.249 70.9191 182.25 70.9669 182.261C71.0147 182.271 71.0599 182.291 71.1 182.32C72.7 183.43 74.41 184.5 76.19 185.49C76.2331 185.514 76.2709 185.546 76.3014 185.585C76.3318 185.623 76.3542 185.668 76.3672 185.715C76.3803 185.763 76.3837 185.812 76.3773 185.861C76.3709 185.91 76.3548 185.957 76.33 186C76.2877 186.064 76.2271 186.115 76.1559 186.146C76.0846 186.176 76.006 186.184 75.93 186.17L76 186.14ZM125.44 183.85C125.381 183.867 125.319 183.867 125.26 183.85C125.217 183.826 125.179 183.794 125.149 183.755C125.118 183.716 125.096 183.672 125.083 183.624C125.07 183.577 125.066 183.527 125.073 183.478C125.079 183.429 125.095 183.382 125.12 183.34C125.43 182.8 125.72 182.24 125.98 181.66C126.537 180.435 126.972 179.159 127.28 177.85C127.306 177.753 127.368 177.67 127.454 177.618C127.54 177.565 127.642 177.548 127.74 177.57C127.836 177.596 127.919 177.658 127.969 177.744C128.02 177.83 128.034 177.933 128.01 178.03C127.684 179.382 127.232 180.701 126.66 181.97C126.39 182.57 126.09 183.16 125.77 183.72C125.727 183.784 125.666 183.833 125.595 183.862C125.523 183.89 125.445 183.897 125.37 183.88L125.44 183.85ZM66.14 179.23C66.052 179.228 65.9672 179.197 65.9 179.14C64.3771 177.794 62.9502 176.344 61.63 174.8C61.561 174.729 61.5223 174.634 61.5223 174.535C61.5223 174.436 61.561 174.341 61.63 174.27C61.6992 174.201 61.7927 174.163 61.89 174.163C61.9873 174.163 62.0807 174.201 62.15 174.27C63.4464 175.782 64.8464 177.202 66.34 178.52C66.409 178.591 66.4476 178.686 66.4476 178.785C66.4476 178.884 66.409 178.979 66.34 179.05C66.3152 179.104 66.2777 179.151 66.2307 179.188C66.1837 179.224 66.1286 179.249 66.07 179.26L66.14 179.23ZM128.32 172.29C128.271 172.29 128.222 172.28 128.176 172.261C128.13 172.241 128.089 172.213 128.055 172.178C128.02 172.142 127.993 172.1 127.975 172.054C127.957 172.008 127.949 171.959 127.95 171.91C127.935 169.921 127.751 167.937 127.4 165.98C127.382 165.882 127.404 165.781 127.46 165.698C127.516 165.616 127.602 165.559 127.7 165.54C127.799 165.525 127.9 165.549 127.982 165.607C128.064 165.664 128.121 165.751 128.14 165.85C128.5 167.85 128.687 169.877 128.7 171.91C128.7 172.01 128.66 172.107 128.589 172.178C128.517 172.25 128.421 172.29 128.32 172.29ZM126.32 160.43C126.239 160.429 126.16 160.402 126.096 160.354C126.031 160.305 125.983 160.237 125.96 160.16C125.45 158.41 124.82 156.55 124.05 154.47C124.031 154.423 124.021 154.373 124.022 154.323C124.023 154.273 124.034 154.223 124.055 154.177C124.075 154.132 124.105 154.09 124.142 154.056C124.179 154.022 124.223 153.996 124.27 153.98C124.363 153.947 124.465 153.952 124.554 153.993C124.644 154.034 124.714 154.108 124.75 154.2C125.53 156.3 126.16 158.2 126.68 159.94C126.708 160.035 126.698 160.138 126.651 160.226C126.604 160.314 126.525 160.38 126.43 160.41L126.32 160.43ZM122.18 149.08C122.111 149.08 122.043 149.061 121.984 149.023C121.925 148.986 121.879 148.933 121.85 148.87C121.21 147.27 120.34 145.43 119.43 143.48V143.38C119.404 143.293 119.41 143.199 119.447 143.116C119.484 143.033 119.55 142.966 119.632 142.927C119.715 142.888 119.808 142.88 119.896 142.905C119.983 142.929 120.059 142.984 120.11 143.06V143.16C121.03 145.16 121.89 146.97 122.53 148.54C122.57 148.634 122.572 148.74 122.535 148.836C122.497 148.931 122.424 149.008 122.33 149.05L122.18 149.08ZM117.18 138.08C117.106 138.082 117.034 138.062 116.971 138.023C116.909 137.984 116.86 137.927 116.83 137.86C115.93 135.77 115.21 133.92 114.64 132.21C114.608 132.115 114.614 132.012 114.657 131.923C114.7 131.833 114.776 131.764 114.87 131.73C114.965 131.698 115.07 131.705 115.16 131.75C115.25 131.795 115.318 131.874 115.35 131.97C115.91 133.66 116.62 135.49 117.52 137.56C117.54 137.605 117.55 137.654 117.551 137.703C117.551 137.752 117.542 137.801 117.523 137.847C117.504 137.892 117.477 137.934 117.442 137.969C117.407 138.004 117.366 138.031 117.32 138.05C117.287 138.085 117.246 138.112 117.2 138.13L117.18 138.08ZM113.52 126.62C113.431 126.618 113.344 126.586 113.277 126.527C113.209 126.469 113.164 126.388 113.15 126.3C112.978 125.228 112.891 124.145 112.89 123.06C112.882 122.09 112.969 121.122 113.15 120.17C113.179 120.081 113.239 120.006 113.32 119.959C113.4 119.912 113.495 119.896 113.587 119.915C113.678 119.933 113.76 119.985 113.816 120.059C113.872 120.134 113.898 120.227 113.89 120.32C113.717 121.223 113.633 122.14 113.64 123.06C113.643 124.108 113.727 125.154 113.89 126.19C113.902 126.287 113.877 126.386 113.819 126.465C113.762 126.545 113.676 126.6 113.58 126.62H113.52ZM116.13 115.26C116.043 115.262 115.958 115.234 115.89 115.18C115.821 115.109 115.782 115.014 115.782 114.915C115.782 114.816 115.821 114.721 115.89 114.65C117.232 113.081 118.866 111.787 120.7 110.84C120.788 110.793 120.89 110.783 120.986 110.811C121.081 110.839 121.161 110.903 121.21 110.99C121.253 111.079 121.261 111.182 121.231 111.276C121.201 111.371 121.137 111.451 121.05 111.5C119.303 112.403 117.748 113.636 116.47 115.13C116.437 115.185 116.39 115.231 116.334 115.262C116.278 115.294 116.214 115.31 116.15 115.31L116.13 115.26ZM156.45 110.36H156.37C154.45 109.96 152.46 109.62 150.45 109.36C150.401 109.354 150.354 109.338 150.312 109.313C150.269 109.289 150.232 109.256 150.202 109.217C150.172 109.178 150.15 109.133 150.138 109.085C150.126 109.038 150.123 108.988 150.13 108.94C150.136 108.891 150.152 108.844 150.176 108.801C150.201 108.759 150.234 108.721 150.273 108.692C150.312 108.662 150.357 108.64 150.404 108.628C150.452 108.615 150.501 108.613 150.55 108.62C152.55 108.88 154.55 109.22 156.55 109.62C156.64 109.64 156.719 109.693 156.773 109.767C156.827 109.842 156.852 109.934 156.843 110.025C156.835 110.117 156.793 110.202 156.726 110.266C156.659 110.329 156.572 110.366 156.48 110.37L156.45 110.36ZM126.45 109.51C126.401 109.515 126.352 109.511 126.305 109.497C126.258 109.483 126.215 109.46 126.177 109.43C126.139 109.399 126.107 109.361 126.083 109.318C126.06 109.275 126.045 109.228 126.04 109.18C126.035 109.131 126.039 109.082 126.053 109.035C126.067 108.988 126.089 108.944 126.12 108.906C126.151 108.868 126.189 108.837 126.231 108.813C126.274 108.79 126.321 108.775 126.37 108.77C128.345 108.327 130.351 108.036 132.37 107.9C132.469 107.894 132.567 107.928 132.641 107.993C132.716 108.059 132.762 108.151 132.77 108.25C132.774 108.299 132.768 108.349 132.753 108.396C132.737 108.443 132.712 108.486 132.68 108.524C132.647 108.561 132.607 108.591 132.563 108.613C132.518 108.635 132.469 108.647 132.42 108.65C130.434 108.778 128.461 109.062 126.52 109.5L126.45 109.51ZM144.45 108.81C142.71 108.69 140.64 108.56 138.45 108.52C138.351 108.517 138.257 108.476 138.188 108.405C138.119 108.334 138.08 108.239 138.08 108.14C138.08 108.09 138.09 108.041 138.109 107.996C138.128 107.95 138.156 107.909 138.192 107.874C138.227 107.84 138.269 107.813 138.315 107.795C138.361 107.777 138.411 107.768 138.46 107.77C140.67 107.82 142.76 107.94 144.46 108.06C144.51 108.062 144.558 108.075 144.603 108.096C144.647 108.118 144.687 108.148 144.72 108.186C144.752 108.223 144.777 108.266 144.793 108.313C144.808 108.361 144.814 108.41 144.81 108.46C144.817 108.55 144.792 108.64 144.739 108.713C144.686 108.787 144.608 108.839 144.52 108.86L144.45 108.81Z",
    fill: "url(#paint36_linear_977_161)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M58.36 170C58.2929 170.001 58.2268 169.984 58.1687 169.95C58.1105 169.917 58.0626 169.868 58.03 169.81C57.5243 168.932 57.0734 168.023 56.68 167.09C56.6604 167.045 56.65 166.996 56.6494 166.947C56.6489 166.897 56.6582 166.848 56.6768 166.803C56.6955 166.757 56.723 166.716 56.7579 166.681C56.7928 166.646 56.8343 166.618 56.88 166.6C56.9716 166.563 57.0741 166.563 57.1655 166.6C57.257 166.638 57.3303 166.709 57.37 166.8C57.7562 167.704 58.1935 168.585 58.68 169.44C58.7174 169.495 58.7384 169.56 58.7408 169.627C58.7432 169.694 58.7269 169.761 58.6936 169.819C58.6604 169.877 58.6115 169.925 58.5526 169.957C58.4936 169.989 58.4269 170.004 58.36 170Z",
    fill: "url(#paint37_linear_977_161)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M179.81 249.041H141.85V256.821H179.81V249.041Z",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.81 249.041H141.85V256.821H179.81V249.041Z",
    fill: "black"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.84 249.041H141.85V256.821H157.84V249.041Z",
    fill: "black"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.85 250.16H175.64L141.85 251.12V250.16Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.81 251.512L150.52 252.242H179.81V251.512Z",
    fill: "black"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.4 253.692L157.84 253.102L179.07 253.692L157.84 254.022L143.4 253.692Z",
    fill: "black"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.85 255.342H166.87L141.85 255.932V255.342Z",
    fill: "black"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.75 255.932L163.04 256.242H179.81L179.75 255.932Z",
    fill: "black"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M174.53 241.262H136.57V249.042H174.53V241.262Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.53 241.262H136.57V249.042H174.53V241.262Z",
    fill: "black"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.56 241.262H136.57V249.042H152.56V241.262Z",
    fill: "black"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.57 242.381H170.36L136.57 243.331V242.381Z",
    fill: "black"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.53 243.73L145.24 244.46H174.53V243.73Z",
    fill: "black"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.11 245.911L152.55 245.311L173.78 245.911L152.55 246.241L138.11 245.911Z",
    fill: "black"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.57 247.551H161.59L136.57 248.151V247.551Z",
    fill: "black"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.47 248.15L157.76 248.46H174.53L174.47 248.15Z",
    fill: "black"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M178.86 233.471H140.9V241.251H178.86V233.471Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.86 233.471H140.9V241.251H178.86V233.471Z",
    fill: "black"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.89 233.471H140.9V241.251H156.89V233.471Z",
    fill: "black"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.9 234.592H174.69L140.9 235.552V234.592Z",
    fill: "black"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.86 235.941L149.57 236.671H178.86V235.941Z",
    fill: "black"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M142.45 238.121L156.89 237.531L178.12 238.121L156.89 238.451L142.45 238.121Z",
    fill: "black"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.9 239.771H165.92L140.9 240.361V239.771Z",
    fill: "black"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.81 240.361L162.1 240.671H178.86L178.81 240.361Z",
    fill: "black"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M204.15 256.662L205.13 252.932H245.69L264.36 254.802L265.07 256.662H204.15Z",
    fill: "#263238"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.69 252.932V256.662H204.15L205.13 252.932H245.69Z",
    fill: "black"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M237.54 235.081C237.594 235.533 237.551 235.992 237.413 236.426C237.276 236.86 237.047 237.26 236.742 237.598C236.436 237.936 236.062 238.205 235.645 238.387C235.227 238.568 234.775 238.658 234.32 238.651H172.2C171.229 238.63 170.298 238.256 169.582 237.599C168.866 236.942 168.414 236.047 168.31 235.081L164.62 195.311C164.58 194.922 164.607 194.53 164.7 194.151C164.872 193.452 165.277 192.833 165.848 192.396C166.418 191.958 167.121 191.727 167.84 191.741H230C230.971 191.762 231.902 192.136 232.618 192.793C233.333 193.45 233.786 194.345 233.89 195.311L237.54 235.081Z",
    fill: "#263238"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M234.1 238.65H172.2C171.229 238.629 170.298 238.255 169.582 237.598C168.866 236.941 168.414 236.046 168.31 235.08L164.62 195.31C164.58 194.922 164.607 194.53 164.7 194.15H226.6C227.571 194.172 228.502 194.545 229.218 195.202C229.933 195.859 230.386 196.754 230.49 197.72L234.18 237.49C234.22 237.879 234.193 238.271 234.1 238.65Z",
    fill: "black"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M191.42 214.262H204.27L200.85 251.052L221.17 254.102V256.662H178.37V254.102L187.14 251.052L191.42 214.262Z",
    fill: "#263238"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M204.27 214.262L194.75 256.082L187.14 255.852L191.42 214.262H204.27Z",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M204.21 417.07H198.09L187.08 263.82H195.21L204.21 417.07Z",
    fill: "#263238"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M204.22 417.07H198.09L187.62 271.44L187.08 264.07H195.21L195.65 271.44L204.22 417.07Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M195.65 271.07H187.62L187.08 264.07H195.21L195.65 271.07Z",
    fill: "black"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M249.17 417.07H243.05L242.05 263.82H250.17L249.17 417.07Z",
    fill: "#263238"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.18 264.07L250.02 288.8L249.18 417.07H243.05L242.21 288.8L242.05 264.07H250.18Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250.18 264.07L250.02 289.07H242.21L242.05 264.07H250.18Z",
    fill: "black"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M314.21 417.07H308.09L297.08 263.82H305.21L314.21 417.07Z",
    fill: "#263238"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.22 417.07H308.09L297.62 271.44L297.08 264.07H305.21L305.65 271.44L314.22 417.07Z",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M305.65 271.07H297.62L297.08 264.07H305.21L305.65 271.07Z",
    fill: "black"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M134.13 417.07H128.01L137.01 263.82H145.14L134.13 417.07Z",
    fill: "#263238"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.14 264.07L144.6 271.44L134.13 417.07H128.01L136.57 271.44L137.01 264.07H145.14Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.01 264.07H145.14L144.6 271.07H136.57L137.01 264.07Z",
    fill: "black"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M130.57 260H311.65V265.51C311.65 265.794 311.594 266.075 311.486 266.337C311.377 266.599 311.218 266.837 311.017 267.037C310.817 267.238 310.579 267.397 310.317 267.506C310.054 267.614 309.774 267.67 309.49 267.67H132.73C132.157 267.67 131.608 267.442 131.203 267.037C130.798 266.632 130.57 266.083 130.57 265.51V260Z",
    fill: "url(#paint38_linear_977_161)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.57 260H311.65V265.51C311.65 265.794 311.594 266.075 311.486 266.337C311.377 266.599 311.218 266.837 311.017 267.037C310.817 267.238 310.579 267.397 310.317 267.506C310.054 267.614 309.774 267.67 309.49 267.67H132.73C132.157 267.67 131.608 267.442 131.203 267.037C130.798 266.632 130.57 266.083 130.57 265.51V260Z",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.65 259.99H130.57V263.83H311.65V259.99Z",
    fill: "black"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M315.45 261H126.77C126.197 261 125.648 260.772 125.243 260.367C124.838 259.962 124.61 259.413 124.61 258.84C124.61 258.266 124.837 257.716 125.242 257.309C125.647 256.902 126.196 256.673 126.77 256.67H315.45C316.024 256.673 316.573 256.902 316.978 257.309C317.383 257.716 317.61 258.266 317.61 258.84C317.61 259.413 317.382 259.962 316.977 260.367C316.572 260.772 316.023 261 315.45 261Z",
    fill: "url(#paint39_linear_977_161)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M315.45 261H126.77C126.197 261 125.648 260.772 125.243 260.367C124.838 259.962 124.61 259.413 124.61 258.84C124.61 258.266 124.837 257.716 125.242 257.309C125.647 256.902 126.196 256.673 126.77 256.67H315.45C316.024 256.673 316.573 256.902 316.978 257.309C317.383 257.716 317.61 258.266 317.61 258.84C317.61 259.413 317.382 259.962 316.977 260.367C316.572 260.772 316.023 261 315.45 261Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M270.81 250L273.13 246.52C273.359 246.178 273.668 245.898 274.031 245.705C274.394 245.511 274.799 245.41 275.21 245.41H278.15C278.394 245.411 278.637 245.448 278.87 245.52L289.36 248.7C289.956 248.878 290.463 249.274 290.78 249.81L292.29 252.34L270.81 250Z",
    fill: "url(#paint40_linear_977_161)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.29 252.34L277 250.68L270.79 250L273.11 246.52C273.339 246.178 273.648 245.898 274.011 245.705C274.374 245.511 274.779 245.41 275.19 245.41H278.13C278.377 245.412 278.623 245.449 278.86 245.52L279.09 245.59L289.34 248.7C289.94 248.877 290.45 249.273 290.77 249.81L292.29 252.34Z",
    fill: "black"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.29 252.342L277 250.682L279.09 245.592L289.34 248.702C289.939 248.878 290.45 249.275 290.77 249.812L292.29 252.342Z",
    fill: "black"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M299.55 256.331V256.661H267.13L268.33 251.971C268.552 251.109 269.056 250.347 269.76 249.803C270.465 249.26 271.33 248.967 272.22 248.971H286.6C287.078 248.968 287.552 249.053 288 249.221L289.8 249.891L296.94 252.551C297.711 252.836 298.375 253.352 298.842 254.029C299.309 254.705 299.556 255.509 299.55 256.331Z",
    fill: "url(#paint41_linear_977_161)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.55 256.331V256.661H286.24L286.95 251.591C286.996 251.277 287.111 250.977 287.288 250.713C287.465 250.449 287.698 250.228 287.971 250.065C288.245 249.903 288.551 249.805 288.867 249.776C289.183 249.748 289.502 249.79 289.8 249.901L296.94 252.561C297.709 252.846 298.372 253.361 298.839 254.035C299.306 254.709 299.554 255.511 299.55 256.331Z",
    fill: "black"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M288.31 253.221L292.55 240.511C292.591 240.381 292.66 240.262 292.753 240.162C292.845 240.062 292.958 239.984 293.084 239.933C293.21 239.881 293.345 239.858 293.481 239.864C293.617 239.871 293.75 239.907 293.87 239.971C294.054 240.076 294.2 240.238 294.287 240.432C294.373 240.626 294.395 240.843 294.35 241.051L290.78 254.611C290.78 254.611 288.41 255.571 288.31 253.221Z",
    fill: "#263238"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.81 255.612H268.93L269.29 253.762H271.17L270.81 255.612Z",
    fill: "black"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.61 255.541H271.73L272.09 253.691H273.97L273.61 255.541Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_161",
    x1: 398.308,
    y1: 348.332,
    x2: 398.308,
    y2: 384.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_977_161",
    x1: 425.849,
    y1: 353.846,
    x2: 425.849,
    y2: 383.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_977_161",
    x1: 422.95,
    y1: 332.078,
    x2: 422.95,
    y2: 385.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_977_161",
    x1: 391.143,
    y1: 344.162,
    x2: 391.143,
    y2: 371.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_977_161",
    x1: 427.893,
    y1: 330.428,
    x2: 427.893,
    y2: 347.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_977_161",
    x1: 431.81,
    y1: 351.949,
    x2: 431.81,
    y2: 368.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_977_161",
    x1: 410.41,
    y1: 385.35,
    x2: 410.41,
    y2: 417.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_977_161",
    x1: 410.41,
    y1: 388.84,
    x2: 410.41,
    y2: 381.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_977_161",
    x1: 277.335,
    y1: 177.77,
    x2: 277.335,
    y2: 230.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_977_161",
    x1: 257.71,
    y1: 177.189,
    x2: 257.71,
    y2: 183.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_977_161",
    x1: 293.618,
    y1: 269.635,
    x2: 293.618,
    y2: 366.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_977_161",
    x1: 243.77,
    y1: 358.18,
    x2: 243.77,
    y2: 367.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_977_161",
    x1: 293.284,
    y1: 300.91,
    x2: 293.284,
    y2: 388.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_977_161",
    x1: 290.865,
    y1: 384.359,
    x2: 290.865,
    y2: 391.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_977_161",
    x1: 328.908,
    y1: 274.139,
    x2: 328.054,
    y2: 265.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_977_161",
    x1: 308.66,
    y1: 275.012,
    x2: 307.806,
    y2: 266.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_977_161",
    x1: 320.855,
    y1: 214.34,
    x2: 320.855,
    y2: 267.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_977_161",
    x1: 327.475,
    y1: 192.074,
    x2: 327.475,
    y2: 203.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_977_161",
    x1: 328.463,
    y1: 174.16,
    x2: 328.463,
    y2: 195.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_977_161",
    x1: 320.12,
    y1: 199.859,
    x2: 320.12,
    y2: 203.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_977_161",
    x1: 328.605,
    y1: 194.121,
    x2: 328.605,
    y2: 201.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_977_161",
    x1: 312.799,
    y1: 201.721,
    x2: 312.799,
    y2: 204.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_977_161",
    x1: 323.25,
    y1: 213.85,
    x2: 323.25,
    y2: 226.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_977_161",
    x1: 313.745,
    y1: 215.07,
    x2: 313.745,
    y2: 225.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_977_161",
    x1: 331.68,
    y1: 210.939,
    x2: 331.68,
    y2: 251.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_977_161",
    x1: 326.135,
    y1: 209.689,
    x2: 326.135,
    y2: 213.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_977_161",
    x1: 232.595,
    y1: 377.439,
    x2: 232.595,
    y2: 393.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_977_161",
    x1: 289.855,
    y1: 400.49,
    x2: 289.855,
    y2: 417.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_977_161",
    x1: 365.305,
    y1: 157.15,
    x2: 365.305,
    y2: 182.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_977_161",
    x1: 352.815,
    y1: 179.361,
    x2: 352.815,
    y2: 193.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_977_161",
    x1: 239.22,
    y1: 138.618,
    x2: 229.963,
    y2: 155.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_977_161",
    x1: 221.284,
    y1: 107.633,
    x2: 221.284,
    y2: 136.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_977_161",
    x1: 226.036,
    y1: 130.16,
    x2: 226.036,
    y2: 135.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_977_161",
    x1: 203.729,
    y1: 115.926,
    x2: 203.729,
    y2: 144.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_977_161",
    x1: 186.955,
    y1: 113.58,
    x2: 186.955,
    y2: 137.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_977_161",
    x1: 163.737,
    y1: 111.164,
    x2: 163.737,
    y2: 112.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_977_161",
    x1: 109.184,
    y1: 107.77,
    x2: 109.184,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_977_161",
    x1: 57.6952,
    y1: 166.572,
    x2: 57.6952,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_977_161",
    x1: 221.11,
    y1: 260,
    x2: 221.11,
    y2: 267.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_977_161",
    x1: 221.11,
    y1: 256.67,
    x2: 221.11,
    y2: 261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_977_161",
    x1: 281.55,
    y1: 245.41,
    x2: 281.55,
    y2: 252.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_977_161",
    x1: 283.34,
    y1: 248.971,
    x2: 283.34,
    y2: 256.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsRafikiIllustration);
export default __webpack_public_path__ + "static/media/Contact Us-Rafiki Illustration.bfbd83c1f82ef273c2847f3e8ed04d7a.svg";
export { ForwardRef as ReactComponent };